{
    "COMMON": {
        "ADD": "Ajouter",
        "APPLY": "Appliquer",
        "ACCESS": "Accéder",
        "CLOSE": "Fermer",
        "ALL": "Tous",
        "MORE": "En savoir plus",
        "CANCEL": "Annuler",
        "DELETE": "Supprimer",
        "CONFIRM": "Valider",
        "EDIT": "Modifier",
        "RESET": "Réinitialiser",
        "RESTORE": "Restaurer",
        "CALL": "Appeler",
        "SAVE": "Sauvegarder",
        "COPY": "Copier",
        "SEARCH_BUTTON": "Rechercher",
        "NEED_UPDATE": "Une mise à jour est disponible",
        "INSTALLATION_FAILED": "Échec de la mise à jour de l'application",
        "NEED_REFRESH": "L'application doit se relancer",
        "NO_DATA_MESSAGE": "Aucune donnée disponible",
        "NO_RESULT": "Pas de résultat",
        "BANNER": "Le support clients et le service commercial de Co-assist pendant cette période d'isolement restent ouverts de <b>9h00 à 18h00</b> et le sont aussi <b>exceptionnellement le samedi et le dimanche.</b>",
        "INVALID_FORM": "Le formulaire n'est pas valide",
        "YOUTUBE": "Voir sur Youtube",
        "HELPER": "Aidant",
        "ADVANCED_MODE": "Mode expert",
        "CONNECTED": "Connecté depuis le {{date}}",
        "DISCONNECTED": "Déconnecté depuis le {{date}}",
        "LOADING": {
            "GENERIC": "Chargement en cours ...",
            "HUB_SERVICE": "Chargement du {{service}} ...",
            "ASSIGNEMENT": "Assignation en cours ...",
            "APPLY_PARAMETERS": "Application des paramètres en cours ..."
        },
        "SELECTOR": {
            "DAILY": "Jour",
            "MONTHLY": "Mois"
        },
        "TOAST": {
            "ERROR_TITLE": "Mince\u00a0!",
            "INTERNET_LOST": "Pas de connexion internet",
            "INTERNET_RENEW": "Connexion internet établie",
            "ERROR_OCCURED": "Une erreur est survenue",
            "ERROR_API_TEXT": "Quelque chose n'a pas fonctionné",
            "ACCESS_DENIED": "L'accès à cette ressource est refusé",
            "API_REQUEST_EXCEEDED": "Nombre de requêtes trop important. Réessayer ou contacter le support.",
            "SERIVCE_UNVAILABLE": "Le service est indisponible pour le moment",
            "CONTINUE": "Vous pouvez continuer votre souscription",
            "NO_ACTION": "Impossible d'afficher pour le moment",
            "SUCCESS_TITLE": "Succès\u00a0!",
            "REQUEST_SENT": "Votre demande a bien été prise en compte",
            "DATA_NOT_AVAILABLE": "Le document n'est pas encore disponible",
            "CUSTOMER_SERVICE": "Le service client a été prévenu de votre demande",
            "ADDRESS_NOT_FOUND": "L'adresse saisie est introuvable",
            "TOO_MUCH_DATA": "Le nombre de données renvoyé est trop important.",
            "ASK_CUSTOMER_SERVICE": " Merci de faire votre demande au service client: contact@co-assist.fr",
            "ALERT_HANDLED": "L'alerte a été prise en charge",
            "ALERT_ACQUITTED": "L'alerte a été acquittée",
            "ALERT_UPDATED": "L'alerte a été mise à jour",
            "SYNC_CAW": "Veuillez poser la montre sur le chargeur afin de synchroniser les paramètres",
            "ADVANCED_MODE_ON": "Le mode expert a été activé pour 15 minutes",
            "ADVANCED_MODE_OFF": "Le mode expert a été désactivé",
            "ADD_USER_SUCCESS": "L'utilisateur a été ajouté",
            "UPDATE_USER_SUCCESS": "L'utilisateur a été mis à jour",
            "DELETE_USER_SUCCESS": "L’utilisateur a été supprimé",
            "COPY_CLIPBOARD": "Texte copié avec succès !",
            "CLIPBOARD_COPY_NOT_SUPPORTED": "Copie dans le presse-papier non supportée",
            "PROFILE_HAS_BEEN_CREATED": "Le profil d'alerte a été créé",
            "PROFILE_HAS_BEEN_RENAMED": "Le profil d'alerte a été renommé",
            "PROFILE_HAS_BEEN_DELETED": "Le profil a été supprimé"
        },
        "TOOLTIP": {
            "EDIT_PROFILE_NAME": "Double clique pour renommer, clique droit pour supprimer"
        },
        "USER_INFO": {
            "ADDRESS": "Adresse",
            "EMAIL": "Email",
            "EMAIL_HINT": "Un email est nécessaire pour se connecter aux applications",
            "NAME": "Nom",
            "FIRST_NAME": "Prénom",
            "LAST_NAME": "Nom",
            "PAYEE": "Bénéficiaire",
            "PHONE_NUMBER": "N° de téléphone",
            "PROM_ID": "Identifiant plateau téléassistance",
            "ADDITIONAL_INFORMATION": "Informations complémentaires",
            "DISPLAY_HINT": "Les informations contenues dans ce champ sont ajoutées au nom afin d'identifier plus précisement l'utilisateur. Exemple: Jacques Martin appartement 28.",
            "USER_ID": "User ID",
            "LOGIN_ID": "Identifiant de connexion",
            "DEFAULT_LANGUAGE": "Langue par défaut pour les services d'alerte",
            "IVR_EXTENSION": "Extension",
            "POST_NUMBER": "extension {{ivrExtension}}",
            "SEND_ON_STATUS": "Envoi d'une alerte lors de  : ",
            "RECOVER_PASSWORD": "Veuillez entrer un adresse valide et valider la fiche utilisateur avant de pouvoir réinitialiser le mot de passe.",
            "STATE_NOTIFICATION": {
                "start": "Début d'alerte",
                "handle": "Prise en charge d'alerte",
                "acquitted": "Fermeture - Acquittement d'alerte",
                "interrupted": "Fermeture - Annulation d'alerte",
                "expired": "Fermeture - Expiration d'alerte",
                "OTHER": "autre{{plural}}"
            },
            "WHATSAPP": {
                "CHECKBOX": "Associer un compte WhatsApp",
                "NUMBER_LINKED": "Numéro WhatsApp associé",
                "SEND_CODE": "Envoyer la demande d'inscription",
                "ENTER_CODE": "Entrez le code de vérification reçu",
                "CODE_NOT_RECEIVED": "Le code est envoyé sur votre appli WhatsApp",
                "VERIFIED": "WhatsApp vérifié",
                "LINK": "Associer",
                "INCORRECT_CODE": "Code incorrect",
                "UNLINK": "Dissocier mon numéro WhatsApp",
                "SELECT": "Sélectionner un aidant"
            },
            "WEBHOOK": {
                "method": "Méthode",
                "url": "URL",
                "headers": "Headers",
                "ADD_HEADER": "Ajouter un header",
                "key": "Clé",
                "value": "Valeur",
                "customBody": "Body personnalisé",
                "availableVariables": "Variables disponibles : ",
                "NO_CUSTOM_BODY": "Standard",
                "CUSTOM_BODY": "Personnalisé",
                "URL_PREVIEW": "Pré-visualisation de l'URL : ",
                "URL_QUERY_ERROR": "Les valeurs de votre body personnalisé ne peuvent pas être vides ou contenir le caractère %",
                "URL_KEY": "Votre entrée : ",
                "URL_VALUE": "Choisissez ou définir une variable : "
            }
        },
        "MODULE_INFO": {
            "MODULEID": "moduleID"
        },
        "DAYS": {
            "MONDAY": "Lundi",
            "TUESDAY": "Mardi",
            "WEDNESDAY": "Mercredi",
            "THURSDAY": "Jeudi",
            "FRIDAY": "Vendredi",
            "SATURDAY": "Samedi",
            "SUNDAY": "Dimanche"
        },
        "CIVILITY": "Civilité",
        "MALE": "Monsieur",
        "FEMALE": "Madame",
        "NOT_DEFINED": "Non défini",
        "INFORMATION": "Information",
        "YES": "Oui",
        "NO": "Non",
        "USER_NAME_PLACEHOLDER": "Identifiant de connexion",
        "BACK": "Retour",
        "CONTINUE": "Continuer",
        "LATER": "Choisir plus tard",
        "SEND": "Envoyer",
        "GO_TO_LOGIN": "Redirection vers la page de connexion",
        "UTC": "UTC",
        "ASK_TO_BE_CALLED": "Vous souhaitez être rappelé(e) par un conseiller\u00a0?",
        "BE_CALLED": "Être appelé(e)",
        "ADVISOR_NOTIFIED": "Un conseiller a été prévenu",
        "RECOMMENDATION": "Souhaitez-vous améliorer la couverture dans le domicile de l’utilisateur ?",
        "FREE": "Gratuit",
        "TIME": {
            "HOURS": "Heures",
            "MINUTES": "Minutes",
            "SECOND": "seconde"
        }
    },
    "ERROR": {
        "404": {
            "TITLE": "Oups ! Erreur 404",
            "BODY": "La page que vous recherchez semble introuvable"
        }
    },
    "VALIDATION": {
        "REQUIRED": "Requis",
        "PICK_CHOICE": "Veuillez choisir l'une des propositions",
        "EMAIL": "Email",
        "PHONE_NUMBER": "N° de téléphone",
        "VERIFY_METHOD": "Quel moyen voulez-vous utiliser pour l'activation de votre compte\u00a0?",
        "VERIFY_TITLE": "Activation du compte de",
        "INVALID_FIELD": "Ce champ n'est pas valide",
        "WRONG_USERID": "Compte invalide",
        "WRONG_EMAIL": "L'email saisi ne correspond pas à l'utilisateur\u00a0:",
        "WRONG_TEL": "Le numéro de téléphone saisi ne correspond pas à l'utilisateur\u00a0:",
        "NON_EXISTENT_USER": "Utilisateur inexistant",
        "ENTER_CODE": "Veuillez saisir votre code de validation",
        "VALIDATION_CODE_ERROR": "Code de vérification incorrect",
        "VALIDATE_SUCCESS": "Votre compte a été validé",
        "EMAIL_VALIDATION_DONE": "Un email de validation a été envoyé",
        "OVERLAPS": "Les plages horaires ne peuvent être superposées",
        "INVALID_TIME_RANGE": "L'heure de début ne peut être postérieure à l'heure de fin",
        "INVALID_JSON_FORMAT": "Le format du code saisi n'est pas valide"
    },
    "GROUP_ASSOCIATIONS": {
        "DELETE": "Supprimer l’utilisateur, toutes ses données et dissocier tous les équipements",
        "BATTERY_LVL": "Batterie\u00a0: {{value}}%",
        "TOAST": {
            "ASSIGN": {
                "SUCCESSFUL_ASSIGNMENT": "Equipement associé avec succès",
                "SUCCESSFUL_UNASSIGNMENT": "Equipement dissocié avec succès"
            }
        },
        "HELPED_ASSOCIATIONS": {
            "DIALOG": {
                "TITLE": "Liste des équipements",
                "CHOOSE_EXISTING": "Associer à un équipement existant",
                "VIRGIN_CONFIGURATION": "Aucune alerte ne sera activée",
                "CHOOSE_CONFIGURATION": "Choix du profil d'alerte",
                "COPY_GROUP_CONFIGURATION": "Etablissement",
                "COPY_PROFILE": "Profil d'alerte '{{name}}'",
                "COPY_USER_CONFIGURATION": "Utilisateur",
                "COPY_NONE_CONFIGURATION": "Vierge",
                "CONFIRM_DIALOG_TITLE": "Dissociation de l'équipement {{moduleID}}",
                "CONFIRM_DIALOG_TEXT": "Êtes-vous sûr de vouloir dissocier cet équipement de cet utilisateur\u00a0?",
                "DELETE_HELPED_TITLE": "Suppression d'un utilisateur",
                "DELETE_HELPED": "Êtes-vous sûr de vouloir supprimer : {{name}}\u00a0?",
                "DELETE_HELPED_WITH_MODULE": "Êtes-vous sûr de vouloir supprimer : {{name}}\u00a0? Tous les équipements associés seront également dissociés."
            },
            "TITLE": "Utilisateurs",
            "ADD_HELPED": "Ajouter un utilisateur",
            "UPDATE_HELPED": "Mise à jour d'un utilisateur",
            "DIALOG_INFO": "Liste des utilisateurs pour lesquels je serai prévenu en cas d'alerte.\nAttention, si aucune montre n'est associée, ou que la personne de dispose pas de l'application Compagnon, aucune alerte ne pourra être détectée.",
            "NO_MODULE": "Pas d'équipement associé",
            "MODULE_IDENTITY": "{{device}}\u00a0: {{moduleID}}",
            "MODULE_NAME": "{{device}} \u00AB {{name}} \u00BB\u00a0: {{moduleID}}",
            "ASSOCIATE": "Associer un équipement à un utilisateur",
            "DISASSOCIATE": "Annuler l’affectation de l'équipement à l’utilisateur et conserver l’utilisateur"
        },
        "MODULE_ASSOCIATIONS": {
            "DIALOG": {
                "TITLE": "Liste des utilisateurs",
                "SELECT_PLACEHOLDER": "Associer à un utilisateur",
                "NO_HELPEDS": "Pas d'utilisateur vacant"
            },
            "TITLE_CAW": "Montre",
            "TITLE_CAB": "Bracelet",
            "TITLE_AlertUnit": "Unité appel malade",
            "TITLE_CALAlertUnit": "Unité appel malade",
            "TITLE_BSSigfox": "Antenne Sigfox",
            "TITLE_BSLora": "Antenne LoRa",
            "TITLE_SimplePack4.0Magnetic": "Détecteur d'ouverture de porte",
            "TITLE_SimplePack4.0Button": "Bouton d'appel",
            "TITLE_I870SF": "Détecteur de fumée",
            "TITLE_I870LR": "Détecteur de fumée",
            "TITLE_GH5200": "Badge mobile GPS",
            "TITLE_TMT250": "Bouton mobile GPS",
            "TITLE_EV07B": "Bouton mobile GPS",
            "TITLE_ARF8170BCA": "Contact sec",
            "TITLE_ARF8171BA": "Contact sec",
            "TITLE_CALDryContact": "Contact sec",
            "TITLE_CALBeacon": "Balise",
            "TITLE_CALDS": "Détecteur d'ouverture de porte",
            "TITLE_CALPear": "Poire d'appel",
            "TITLE_CALToggle": "Tirette d'appel",
            "TITLE_Luna4G": "Borne Luna",
            "TITLE_TAGID": "Tag",
            "TITLE_CALWornBracelet": "Bouton d'appel mobile",
            "TITLE_CALSimpleButton": "Bouton d'appel fixe",
            "TITLE_NetworkDevice": "Appareil réseau",
            "TITLE_LDS02DS": "Détecteur d'ouverture de porte",
            "TITLE_LDS02SimpleButton": "Bouton d'appel",
            "TITLE_VH2BBUS01": "Radar",
            "TITLE_ZEPRLR": "Détecteur de fumée",
            "TITLE_ZEECDMINOLR": "Compteur d'eau",
            "TITLE_LHT65NLR": "Capteurs de température",
            "TITLE_X865LSOrigin": "Détecteur de fumée",
            "TITLE_X855LSGuard": "Détecteur de fumée",
            "TITLE_X870LSOriginPlus": "Détecteur de fumée",
            "TITLE_X860LSGuardPlus": "Détecteur de fumée",
            "TITLE_WSM02": "Capteur de présence au lit",
            "NO_MODULE_FOUND": "Pas d'équipement disponible",
            "DIALOG_INFO": "Liste des équipements qui m'appartiennent. Je peux les associer à n'importe quel utilisateur de la liste précédente.",
            "ASSOCIATED_WITH": "Associé à {{name}}",
            "NOT_ASSOCIATED": "Non associé",
            "ASSOCIATE": "Associer l'équipement à un utilisateur",
            "DISASSOCIATE": "Dissocier l'équipement de l'utilisateur"
        }
    },
    "ADMINISTRATION": {
        "BATTERY_TO_BE_CHARGED": {
            "TITLE": "Montres à recharger ({{number}})"
        },
        "DEVICE_TO_BE_SYNC": {
            "TITLE": "Montres à synchroniser ({{number}})",
            "NO_DEVICE_TO_SYNC": "Toutes les montres sont synchronisées"
        },
        "PARC_STATUS": {
            "TITLE": "État du parc",
            "USED": "Équipements associés",
            "NON_FUNCTIONAL": "dont équipements fonctionnels"
        },
        "NUMBER_OF_ALERTS": {
            "TITLE": "Visualisation des alertes de la semaine"
        },
        "ADMIN_USERS_DASHBOARD": {
            "TITLE": "Tableau des utilisateurs",
            "SELECT_TEXT": "Tout",
            "NO_DATA_MESSAGE": "Aucune donnée disponible",
            "COLUMNS": {
                "MODULE_STATE": {
                    "TITLE": "État du service",
                    "SELECT": {
                        "OK_MODULE_STATE": "Service opérationnel",
                        "ISSUE_MODULE_STATE": "Deux derniers messages de routine non reçus",
                        "WARNING_MODULE_STATE": "Dernier message de routine non reçu",
                        "UNKNOWN_MODULE_STATE": "Pas d'information"
                    }
                },
                "BATTERY_LEVEL": {
                    "TITLE": "Niveau de batterie"
                },
                "CONNECTIVITY": {
                    "TITLE": "Connectivité"
                },
                "IN_ALERT": {
                    "TITLE": "Alerte ouverte",
                    "SELECT": {
                        "NO_ALERT": "Pas d'alerte",
                        "IN_ALERT": "En alerte",
                        "BUTTON": "Appui du bouton",
                        "INACTIVITY": "Détection d'immobilité",
                        "FALL": "Alerte de chute",
                        "ZONE_EXIT": "Alerte de sortie de zone",
                        "LOW_BATTERY": "Alerte de batterie faible",
                        "CRITICAL_BATTERY": "Alerte de batterie vide",
                        "SMOKE": "Alerte de détection de fumée"
                    }
                },
                "EQUIPPED": {
                    "TITLE": "Utilisateur équipé",
                    "SELECT": {
                        "USER_EQUIPPED": "Utilisateur équipé",
                        "USER_NOT_EQUIPPED": "Utilisateur non équipé"
                    }
                }
            }
        }
    },
    "PASSWORD_RESET": {
        "ERROR_TOAST": "La communication avec le serveur a échoué ou identifiant incorrect",
        "EMAIL_ERROR": "Cet utilisateur n'a pas d'email associé",
        "GO_BACK": "< Revenir",
        "RESET_PASSWORD": "Réinitialiser le mot de passe",
        "CONFIRM_RESET_PASSWORD": "Voulez-vous vraiment réinitialiser le mot de passe\u00a0?",
        "MANDATORY_FIELD": "Le champ est obligatoire",
        "INCORRECT_LOGIN": "Identifiant incorrect",
        "LOGIN_PLACEHOLDER": "Identifiant de connexion",
        "SUCCESS_TEXT": "Demande de réinitialisation de mot de passe effectuée.",
        "SUCCESS_TITLE": "Veuillez suivre les instructions présentes dans l'email que nous allons vous envoyer.",
        "SUCCESS_GO_TO_LOGIN": "Aller vers la page de connexion.",
        "AUTO_REDIRECT_TO_LOGIN": "Vous allez être redirigé vers la page de connexion.",
        "ERROR_TO_SHORT": "Votre mot de passe doit contenir au moins 6 caractères",
        "NEW_PASSWORD_FOR": "Nouveau mot de passe pour {{arg}}",
        "DIFFERENT_PASSWORD_NEEDED": "Vous ne pouvez pas utiliser votre ancien mot de passe",
        "ALL_FIELDS_MANDATORY": "Tous les champs sont obligatoires",
        "PASSWORDS_DONT_MATCH": "Les mots de passe ne sont pas les mêmes",
        "NEW_PASSWORD_PLACEHOLDER": "Nouveau mot de passe",
        "PASSWORD_CONFIRMATION_PLACEHOLDER": "Confirmation du nouveau mot de passe",
        "RESET_SUCCESS": "Votre mot de passe a bien été réinitialisé.",
        "REQUEST_CHANGE_PASSWORD": "Réinitialiser votre mot de passe",
        "WRONG_LINK_TITLE": "Le lien utilisé pour la réinitialisation du mot de passe est incorrect",
        "WRONG_LINK_TEXT": "Si vous voulez réinitialiser votre mot de passe, cliquez ici",
        "OLD_LINK_TITLE": "Le lien utilisé pour la réinitialisation du mot de passe a expiré",
        "OLD_LINK_TEXT": "Si vous voulez recevoir un nouveau lien, cliquez ici"
    },
    "EXIT_AREA": {
        "TITLE": "Configuration de la zone de vie",
        "DIALOG_INFO": "Si la fonctionnalité \"Suivi de position\" est activée, la position est relevée toutes les 5 minutes dès que la montre est en mouvement. Dans le cas contraire, la position n'est relevée qu'en cas d'alerte.",
        "CIRCULAR_ZONE_BUTTON": "Zone circulaire",
        "PATH_ZONE_BUTTON": "Zone polygonale",
        "ROOM": "Pièce",
        "ROOMSET": "Agrégation de pièces",
        "ZONE_DELIMITATION": "Délimitation de la zone",
        "PLEASE_FILL_ADDRESS": "Merci de remplir l'adresse qui constituera le centre du cercle et de définir le rayon de celui-ci.",
        "POLYGON_HELP": "<p>La zone de vie est la zone dans laquelle l'utilisateur peut se déplacer sans qu'une alerte soit émise.</p> <p>Vous avez le choix entre définir une zone circulaire ou tracer un polygone directement sur la carte</p>",
        "INOUT_ZONE_EXIT_HELP": "<p>La zone de vie est lsa zone dans laquelle l'utilisateur peut se déplacer sans qu'une alerte soit émise.</p> <p>Vous avez le choix entre la zone de couverture du radar ou l'agrégation des zones de couverture des radars associés à l'utilisateur/pièce</p>",
        "ROOM_EXPLANATION": "Une alerte est créée si l'utilisateur a quitté la zone de couverture du radar",
        "ROOMSET_EXPLANATION": "Une alerte est créée si l'utilisateur a quitté la zone de couverture des radars qui lui sont associés.",
        "CHANGED_APPLIED_TO_OTHERS": "La configuration de ce radar sera également appliquée aux radars {{moduleIDs}}",
        "ROOMSET_LIST_MODULES": "La zone aggrégée comprend les radars: {{moduleIDs}}",
        "RESTART_BUTTON": "Recommencer",
        "ADDRESS_ZONE_CENTER": "Adresse (centre du cercle)",
        "SEARCH_BUTTON": "Centrer la carte",
        "MAP_POSITIONING": "Positionnement",
        "MAP_POSITIONING_DESCRIPTION": "Vous pouvez positionner la carte à la main ou bien via une adresse.",
        "MAP_ADDRESS_POSITIONING": "Positionnement de la carte via une adresse",
        "RADIUS_SIZE": "Distance (rayon du cercle)",
        "TOAST": {
            "SUCCESS": "Configuration de la zone effectuée",
            "POLY_ERROR": "Veuillez entrer au moins 3 points de délimitations"
        },
        "CHOOSE_ZONE_TYPE": "Vous devez choisir le type de tracé souhaité.",
        "START_CIRCULAR": "Cliquer sur la carte pour définir le centre de la zone ou entrer l'adresse dans le champ \"Adresse\".",
        "TIPS_CIRCULAR": "Maintenir le clique sur le centre de la zone et glisser pour le déplacer.",
        "START_POLYGON": "Cliquer sur la carte pour définir l'emplacement des sommets de la zone de vie.",
        "TIPS_POLYGON": " Cliquer droit pour supprimer un sommet, maintenir le clic sur un sommet et glisser pour le déplacer."
    },
    "MANAGE_ALERT_PROCESS": {
        "TITLE": "Gestion des processus d'alerte de {{name}}",
        "TITLE_GROUP": "Processus d'alerte de l'établissement",
        "TITLE_CONFIGURATION": "Configuration",
        "TITLE_ID": "Identification",
        "NO_DESCRIPTION": "Aucune description",
        "CALL_ORDER": "Ordre de contact des aidants",
        "TITLE_ASK_HELPER_TO_MANAGE_ALERT_CALL": "Si l'alerte n'a pas été acquittée 15 min après la prise en charge",
        "TEXT_ASK_HELPER_TO_ACQUIT_INSITU_ALERT_CALL": "L'aidant est rappelé toutes les 15 minutes jusqu'à ce que l'alerte soit acquittée in situ",
        "TEXT_ASK_HELPER_TO_ACQUIT_ALERT_CALL": "L'aidant est rappelé toutes les 15 minutes pour acquitter l'alerte par téléphone",
        "NO_OPTION": "L'aidant n'est pas rappelé",
        "TITLE_FIRST_CALL": "Appel à l'utilisateur en premier",
        "TEXT_FIRST_CALL": "L'utilisateur est appelé en premier pour pouvoir le cas échéant annuler l'alerte",
        "PROCESS_ACTIONS_TYPE": "Modalité de contact des aidants",
        "NUMBER_OF_CYCLE": "Nombre de cycles d'appel",
        "NUMBER_OF_CALL": "Nombre de fois où les aidants sont contactés",
        "PROCESS_DESCRIPTION": "Description du processus",
        "PROCESS_NAME": "Nom du processus",
        "RECEPTIONIST_NAME": "Nom de l'aidant",
        "CASCADE": "Les aidants sont appelés les uns à la suite des autres",
        "PARALLEL": "Les aidants sont appelés simultanément",
        "AUTOMATIC_CHOICE": "Si possible, le système choisit seul les aidants les plus proches par géolocalisation",
        "AUTOMATIC_CHOICE_INFO": "S'applique si les aidants utilisent l'application mobile\u00a0; sinon l'ordre choisi par l'utilisateur est conservé.",
        "HELPERS_LIST_MANDATORY": "Au moins un aidant à contacter doit être désigné",
        "HELPERS_LIST_TITLE": "Les aidants qui vont être contactés",
        "AVAILABLE_HELPERS_LIST_TITLE": "Aidants disponibles",
        "NO_AVAILABLE_HELPERS_TITLE": "Vous n'avez plus d'aidant à utiliser",
        "ARROW_HINT_UP": "Avancer dans la liste",
        "ARROW_HINT_DOWN": "Descendre dans la liste",
        "ADD_TO_PROCESS_HINT": "Ajouter à la liste des aidants à contacter",
        "DELETE_FROM_PROCESS_HINT": "Ne pas contacter cet aidant lors de ce processus",
        "ADD_NEW_ALERT_PROCESS": "Créer un processus d'alerte",
        "NEW_ALERT_PROCESS": "Nouveau processus d'alerte",
        "UPDATE_ALERT_PROCESS": "Modifier le processus d'alerte",
        "ERROR_PROCESS_NAME_ALREADY_EXIST": "Ce nom de processus est déjà utilisé",
        "ERROR_PROCESS_DATA_HELPER": "Vous devez au moins choisir un aidant",
        "TOASTR_SUCCESS": "La liste des processus a été mise à jour",
        "DISCLAIMER_DELETE_PROCESS": "<b>La suppression du processus peut entraîner une rupture dans la chaîne d'alerte si ce processus est toujours utilisé.</b><br>",
        "CONFIRMATION_DELETE_PROCESS": "Voulez-vous vraiment supprimer ce processus\u00a0?",
        "FORMAT_TITLE": "Format des appels",
        "TECHNICAL_FORMAT_TEXT": "Utiliser le format concis pour les appels téléphoniques",
        "TECHNICAL_FORMAT_HELP": "<p>Le format concis est un format condensé permettant un accès rapide aux informations de l'alerte.</p><div class='alert alert-success'>&laquoAlerte Co-assist. (Type d'alerte), (Nom de l'utilisateur). Alerte lancée il y a (Durée) minutes, pour prendre en charge l'alerte appuyez sur 1&raquo</div>"
    },
    "MANAGE_ADMIN": {
        "TITLE": "Gestion des administrateurs",
        "DIALOG_INFO": "<p>Les administrateurs sont les personnes qui peuvent gérer le compte. Merci de vous tourner vers votre support client pour leur création ou suppression.</p>"
    },
    "MANAGE_HELPER": {
        "TITLE": "Gestion des aidants",
        "DIALOG_INFO": "<p>Les aidants sont les personnes qui peuvent porter assistance à l'utilisateur en cas d'alerte. Plus le nombre d'aidant est élevé plus la probabilité que l'un d'eux soit disponible au moment d'une alerte est importante.</p><p>Un email est nécessaire pour avoir un mot de passe permettant de se connecter aux applications web ou mobile.</p><p>Les administrateurs sont les personnes qui peuvent gérer le compte. Ils sont signalés par l'icone 🛡️. Merci de vous tourner vers votre support client pour leur création ou suppression.</p>",
        "IVR_TOOLTIP": "Cet utilisateur est joignable via un serveur vocal interactif avec l'extension {{ivrExtension}}",
        "ERROR_LAST_HELPER": "Vous devez avoir au minimum 1 aidant",
        "ERROR_IVR_MAX_LENGTH": "L'extension ne peut pas dépasser {{maxLength}} caractères",
        "CONNECTED_TO_MOBILE_APP": "Dispositifs connectés à l'application : {{number}}",
        "ADD_HELPER": {
            "ACTION": "Ajouter un aidant",
            "TITLE": "Nouvel aidant",
            "BUTTON": "Ajouter l'aidant",
            "FINAL_BUTTON": "Valider l'inscription",
            "CONFIRM_ADD_HELPER": "Confirmez-vous l'ajout de l'aidant\u00a0?",
            "SUCCESS_WHATSAPP_VERIFICATION": "Votre compte WhatsApp est désormais associé",
            "SUCCESS_WHATSAPP_UNLINKED": "Votre compte WhatsApp est désormais dissocié"
        },
        "UPDATE_HELPER": {
            "TITLE": "Mise à jour d'un aidant",
            "BUTTON": "Mettre à jour l'aidant"
        },
        "DELETE_HELPER": {
            "TITLE": "Suppression d'un aidant",
            "WARNING": "Si cet aidant n'a aucune autre relation, son compte sera définitivement supprimé.",
            "WARNING_B2B": "La suppression de cet aidant engendre sa suppression de tous les autres processus.",
            "CONFIRMATION": "Confirmez-vous la suppression de : {{name}}\u00a0?"
        },
        "INFO": {
            "TITLE": "Informations sur l'aidant",
            "TEXT": "<b>Extension</b><br/>Dans le cas le d’un PBX, permet d’atteindre un aidant via son extension (DECT)."
        }
    },
    "CONFIRMATION_ALERT": "Voulez-vous vraiment supprimer cette alerte\u00a0?",
    "zoneExit": "Sortie de zone",
    "fall": "Détection de chute",
    "button": "Appui du bouton de la montre",
    "buttonBracelet": "Appui du bouton du bracelet",
    "buttonSole": "Appel malade",
    "buttonCau1": "Bouton appel malade",
    "buttonCau2": "Demande de renfort",
    "buttonCall": "Appel direct",
    "buttonTmt": "Appui du bouton mobile GPS",
    "endOfLifeBattery": "Batterie vide",
    "inactivity": "Détection d'immobilité",
    "criticalBattery": "Batterie vide",
    "lowBattery": "Batterie faible",
    "smoke": "Détection de fumée",
    "openDoor": "Détection d'ouverture de porte",
    "dc1": "Contact Sec n°1",
    "dc2": "Contact Sec n°2",
    "dc3": "Contact Sec n°3",
    "dc4": "Contact Sec n°4",
    "disconnection": "Déconnexion",
    "nonFunctionnal": "Dispositif non fonctionnel",
    "prolongedPresence": "Présence prolongée",
    "threshold": "Dépassement de seuil",
    "leak": "Détection de fuite",
    "DEVICE_TYPE": {
        "BSSigfox": "Antenne Sigfox",
        "BSLora": "Antenne LoRa",
        "CAW": "Montre",
        "CAB": "Bracelet",
        "AlertUnit": "Unité appel malade",
        "SimplePack4.0Magnetic": "Détecteur d'ouverture de porte",
        "SimplePack4.0Button": "Bouton d'appel",
        "I870SF": "DAAF I870SF",
        "I870LR": "DAAF I870LR",
        "ZEPRLR": "DAAF",
        "X865LSOrigin": "DAAF X865LS",
        "X855LSGuard": "DAAF X855LS",
        "X870LSOriginPlus": "DAAF X870LS Plus",
        "X860LSGuardPlus": "DAAF X860LS Plus",
        "ZEECDMINOLR": "Compteur d'eau",
        "_ZEECDMINOLR_hot": "Compteur d'eau chaude",
        "_ZEECDMINOLR_cold": "Compteur d'eau froide",
        "LHT65NLR": "Capteur de température",
        "GH5200": "Badge mobile GPS",
        "TMT250": "Bouton mobile GPS",
        "EV07B": "Bouton mobile GPS",
        "ARF8170BCA": "Contact sec",
        "ARF8171BA": "Contact sec",
        "Smartphone": "Smartphone",
        "CAU": "Unité appel malade",
        "CALAlertUnit": "Unité appel malade",
        "CALDryContact": "Contact sec",
        "CALBeacon": "Balise",
        "CALDS": "Détecteur d'ouverture de porte",
        "CALPear": "Poire d'appel",
        "CALToggle": "Tirette d'appel",
        "Luna4G": "Borne Luna",
        "TAGID": "Tag",
        "CALWornBracelet": "Bouton d'appel mobile",
        "CALSimpleButton": "Bouton d'appel fixe",
        "NetworkDevice": "Appareil réseau",
        "LDS02DS": "Détecteur d'ouverture de porte",
        "LDS02SimpleButton": "Bouton d'appel",
        "VH2BBUS01": "Radar",
        "WSM02": "Capteur de présence au lit",
        "undefined": "Inconnu"
    },
    "DEVICE": {
        "TITLE_MODAL": "Configuration de l'équipement",
        "TITLE_CAW": "Configuration de la montre {{moduleID}}",
        "TITLE_CAW_UNSYNC": "Configuration de la montre {{moduleID}} non synchronisée",
        "TITLE_CAB": "Configuration du bracelet {{moduleID}}",
        "TITLE_AlertUnit": "Configuration de l'unité appel malade {{moduleID}}",
        "TITLE_CALAlertUnit": "Configuration de l'unité appel malade {{moduleID}}",
        "TITLE_SimplePack4.0Magnetic": "Configuration du détecteur d'ouverture de porte {{moduleID}}",
        "TITLE_SimplePack4.0Button": "Configuration du bouton d'appel {{moduleID}}",
        "TITLE_I870SF": "Configuration du détecteur de fumée {{moduleID}}",
        "TITLE_I870LR": "Configuration du détecteur de fumée {{moduleID}}",
        "TITLE_ZEPRLR": "Configuration du détecteur de fumée {{moduleID}}",
        "TITLE_ZEECDMINOLR": "Configuration du compteur d'eau {{moduleID}}",
        "TITLE_X865LSOrigin": "Configuration du détecteur de fumée {{moduleID}}",
        "TITLE_X855LSGuard": "Configuration du détecteur de fumée {{moduleID}}",
        "TITLE_X870LSOriginPlus": "Configuration du détecteur de fumée {{moduleID}}",
        "TITLE_X860LSGuardPlus": "Configuration du détecteur de fumée {{moduleID}}",
        "TITLE_ZEECDMINOLR_hot": "Configuration du compteur d'eau chaude {{moduleID}}",
        "TITLE_ZEECDMINOLR_cold": "Configuration du compteur d'eau froide {{moduleID}}",
        "TITLE_LHT65NLR": "Configuration du capteur de température {{moduleID}}",
        "TITLE_GH5200": "Configuration du badge mobile GPS {{moduleID}}",
        "TITLE_TMT250": "Configuration du bouton mobile GPS {{moduleID}}",
        "TITLE_EV07B": "Configuration du bouton mobile GPS {{moduleID}}",
        "TITLE_ARF8170BCA": "Configuration du contact sec {{moduleID}}",
        "TITLE_ARF8171BA": "Configuration du contact sec {{moduleID}}",
        "TITLE_CALDS": "Configuration du détecteur d'ouverture de porte {{moduleID}}",
        "TITLE_CALDryContact": "Configuration du contact sec {{moduleID}}",
        "TITLE_CALBeacon": "Configuration de la balise {{moduleID}}",
        "TITLE_CALToggle": "Configuration de la tirette d'appel {{moduleID}}",
        "TITLE_Luna4G": "Configuration de borne Luna {{moduleID}}",
        "TITLE_TAGID": "Pas de configuration disponible {{moduleID}}",
        "TITLE_CALPear": "Configuration de la poire d'appel {{moduleID}}",
        "TITLE_CALWornBracelet": "Configuration du bouton d'appel mobile {{moduleID}}",
        "TITLE_CALSimpleButton": "Configuration du bouton d'appel fixe {{moduleID}}",
        "TITLE_NetworkDevice": "Network device",
        "TITLE_LDS02DS": "Configuration du détecteur d'ouverture de porte {{moduleID}}",
        "TITLE_LDS02SimpleButton": "Configuration du bouton d'appel {{moduleID}}",
        "TITLE_VH2BBUS01": "Configuration du radar {{moduleID}}",
        "TITLE_WSM02": "Configuration du capteur de présence au lit {{moduleID}}",
        "TITLE_DEFAULT": "Configuration de la montre par défaut",
        "TITLE_B2B": "Configuration des profils d'alerte",
        "HINT_INFO": "Plus d'information",
        "DIALOG_INFO_CAW": "Les réglages du système se font à partir de cette interface. Pour que les modifications soient prises en compte, il faut recharger la montre.",
        "DIALOG_INFO_CAB": "Les réglages du système se font à partir de cette interface.",
        "DIALOG_INFO_AlertUnit": "Les réglages du système se font à partir de cette interface.",
        "DIALOG_INFO_CALAlertUnit": "Les réglages du système se font à partir de cette interface.",
        "DIALOG_INFO_SimplePack4.0Magnetic": "Les réglages du détecteur d'ouverture de porte se font à partir de cette interface.",
        "DIALOG_INFO_SimplePack4.0Button": "Les réglages du bouton d'appel se font à partir de cette interface.",
        "DIALOG_INFO_I870SF": "Les réglages du système se font à partir de cette interface.",
        "DIALOG_INFO_I870LR": "Les réglages du système se font à partir de cette interface.",
        "DIALOG_INFO_ZEPRLR": "Les réglages du système se font à partir de cette interface.",
        "DIALOG_INFO_X865LSOrigin": "Les réglages du système se font à partir de cette interface.",
        "DIALOG_INFO_X855LSGuard": "Les réglages du système se font à partir de cette interface.",
        "DIALOG_INFO_X870LSOriginPlus": "Les réglages du système se font à partir de cette interface.",
        "DIALOG_INFO_X860LSGuardPlus": "Les réglages du système se font à partir de cette interface.",
        "DIALOG_INFO_ZEECDMINOLR": "Les réglages du système se font à partir de cette interface.",
        "DIALOG_INFO_LHT65NLR": "Les réglages du système se font à partir de cette interface.",
        "DIALOG_INFO_GH5200": "<p>Les réglages du système se font à partir de cette interface.</p><a href='https://support.co-assist.fr/notice-badge-gps' target='_blank'>Accéder à la notice d'utilisation du badge mobile GPS</a>",
        "DIALOG_INFO_TMT250": "<p>Les réglages du système se font à partir de cette interface.</p><a href='https://support.co-assist.fr/notice-bouton-gps' target='_blank'>Accéder à la notice d'utilisation du bouton mobile GPS</a>",
        "DIALOG_INFO_EV07B": "<p>Les réglages du système se font à partir de cette interface.</p><a href='https://support.co-assist.fr/notice-bouton-gps' target='_blank'>Accéder à la notice d'utilisation du bouton mobile GPS</a>",
        "DIALOG_INFO_ARF8170BCA": "<p>Les réglages du système se font à partir de cette interface.</p><a href='https://support.co-assist.fr/contact-sec-installation' target='_blank'>Accéder à la notice d'utilisation du contact sec</a>",
        "DIALOG_INFO_ARF8171BA": "<p>Les réglages du système se font à partir de cette interface.</p><a href='https://support.co-assist.fr/contact-sec-installation' target='_blank'>Accéder à la notice d'utilisation du contact sec</a>",
        "DIALOG_INFO_CALDS": "Les réglages du détecteur d'ouverture de porte se font à partir de cette interface.",
        "DIALOG_INFO_CALToggle": "Les réglages de la tirette d'appel se font à partir de cette interface.",
        "DIALOG_INFO_Luna4G": "Les réglages de la borne Luna se font à partir de cette interface.",
        "DIALOG_INFO_TAGID": "Pas de réglage disponible.",
        "DIALOG_INFO_CALDryContact": "Les réglages du contact sec se font à partir de cette interface.",
        "DIALOG_INFO_CALPear": "Les réglages de la poire d'appel se font à partir de cette interface.",
        "DIALOG_INFO_CALWornBracelet": "Les réglages du bouton d'appel mobile se font à partir de cette interface.",
        "DIALOG_INFO_CALSimpleButton": "Les réglages du bouton d'appel se font à partir de cette interface.",
        "DIALOG_INFO_LDS02DS": "Les réglages du détecteur d'ouverture de porte se font à partir de cette interface.",
        "DIALOG_INFO_LDS02SimpleButton": "Les réglages du bouton d'appel se font à partir de cette interface.",
        "DIALOG_INFO_VH2BBUS01": "Les réglages du radar se font à partir de cette interface.",
        "DIALOG_INFO_WSM02": "Les réglages du capteur de présence au lit se font à partir de cette interface.",
        "UNAVAILABLE_FUNCTIONS": "La version du logiciel de votre montre ne vous permet pas de bénéficier de cette fonctionnalité. Contactez le support pour plus d'informations.",
        "UNAVAILABLE_MODULE": "Aucun bracelet ou montre n'est associé à cet utilisateur. Contactez le support pour plus d'informations.",
        "HAVE_UPDATED_ALERT": "Vous avez mis à jour l'alerte",
        "HAVE_UPDATED_SETTING": "Vous avez mis à jour le paramètre",
        "COPY_CONFIGURATION_TITLE": "Dupliquer la configuration",
        "COPY_CONFIGURATION_BODY": "Sélectionner les alertes sur lesquelles appliquer la configuration <strong>&laquo;{{alert}}&raquo;</strong>",
        "SAVE_ALERT_SETTINGS": {
            "ACTION": "Sauvegarder cette configuration comme configuration par défaut",
            "ACTION_B2B": "Je souhaite conserver la configuration de l'utilisateur",
            "SUCCESS": "La configuration par défaut a été sauvegardée"
        },
        "RESET_ALERT_SETTINGS": {
            "USER_ACTION": "Rétablir la configuration par défaut de l'utilisateur",
            "NO_USER_ACTION": "Aucune configuration par défaut définit pour cet utilisateur",
            "GROUP_ACTION": "Appliquer un profil d'alerte",
            "SUCCESS": "La configuration a été appliquée à l'utilisateur"
        },
        "APPLY_DEFAULT": {
            "ALERTS_ACTION": "Propager le profil d'alerte",
            "CONFIG_ACTION": "Propager la configuration de la montre",
            "TITLE": "Propagation du profil d'alerte '{{name}}'",
            "OPTIONS": {
                "APPLY_ALL_SETTINGS": "Appliquer l'ensemble de la configuration (hors suivi de position)",
                "SELECT_SETTINGS": "Sélectionner les paramètres à appliquer",
                "APPLY_ALL_USERS": "Appliquer à l'ensemble des utilisateurs",
                "SELECT_USERS": "Sélectionner les utilisateurs",
                "SELECT_DEVICE_TYPES": "Sélectionner les dispositifs",
                "APPLY_ALL_DEVICE_TYPES": "Appliquer à l'ensemble des dispositifs compatibles"
            },
            "CONFIRM_ALERTS": "Le profil d'alerte choisi écrasera l'ensemble des anciennes configurations.",
            "CONFIRM_SETTINGS": "La configuration choisie écrasera l'ensemble des anciennes configurations.",
            "SUCCESS": "La configuration a été propagée aux utilisateurs sélectionnés"
        },
        "CONFIG_ALERTS": {
            "TITLE": "Alertes",
            "TITLE_SUFFIX": "Alertes {{suffix}}",
            "HINT_SCHEDULE": "Planification des jeux de notifications",
            "HINT_button": "Durée de l'appui du bouton",
            "HINT_zoneExit": "Délimitation de la zone de vie",
            "HINT_CONFIG": "Configuration des jeux de notifications",
            "HINT_ALERT_LATENCY": "Réactivité de l'alerte",
            "HINT_ALERT_THRESHOLD": "Définition du seuil",
            "HINT_PROBE_PRESENCE": "Présence de la sonde",
            "WARNING_REAL_TIME_TRACKER": "Attention : L'activation du suivi de position diminue fortement l'autonomie de la montre. Une utilisation efficace du suivi de position nécessite une formation préalable.",
            "DESCRIPTION": {
                "criticalBattery": "Si cette option est activée, une alerte vous est automatiquement envoyée lorsque la montre n'a plus de batterie.",
                "lowBattery": "Si cette option est activée, une alerte vous est automatiquement envoyée lorsque le niveau de batterie atteint 15\u00a0%.",
                "alertDuration": "La durée des alertes est le temps pendant lequel l'alerte peut être annulée ou acquittée dans le cadre d'un usage en établissement.",
                "inactivity": "Cette fonctionnalité permet de détecter lorsque la montee ne bouge pas pendant le temps configuré (réactivité de l'alerte). La réactivité minimum, 1h30, est le temps nécessaire pour s'assurer que la montre est distinctement immobile, et non pas dans une situation assimilable comme le sommeil de l'utilisateur. Configurer une réactivité plus longue vous permet d'adapter l'usage, par exemple si l'utilisateur souhaite enlever sa montre pendant la nuit. En général, une alerte d'immobilité signifie que la montre n'est plus portée par l'utilisateur.",
                "zoneExit": "Si cette option est activée, la position du porteur est relevée et transmise si le porteur s'est déplacé depuis le dernier relevé. Les positions sont généralement précises à quelques kilomètres en intérieur et quelques mètres en extérieur. La position précise n'est trouvée que si l'utilisateur se déplace à un rythme normal. Pour annuler une alerte de sortie de zone, il est nécessaire qu'une position soit détectée à l'intérieur de la zone de vie.",
                "fall": "Si cette option est activée, la montre détecte automatiquement les chutes lourdes suivies d'une immobilité au sol. Dès qu'une chute est détectée, la montre vibre et une petite lumière clignote. Pour annuler l'envoi d'une alerte de chute, il faut appuyer quelques secondes sur le bouton d'alerte. La montre vibre et le clignotement de la petite lumière s'arrête.",
                "button": "Si cette option est activée, le bouton d'alerte de la montre permet d'envoyer des alertes. En cas d'appui sur le bouton, la montre vibre et une petite lumière clignote. Pour annuler l'envoi d'une alerte, il faut appuyer quelques secondes sur le bouton d'alerte. La montre vibre de nouveau et le clignotement de la petite lumière s'arrête.",
                "buttonBracelet": "Si cette option est activée, le bouton d'alerte du bracelet permet d'envoyer des alertes. En cas d'appui sur le bouton, la montre vibre et une petite lumière clignote. Pour annuler l'envoi d'une alerte, il faut appuyer quelques secondes sur le bouton d'alerte. La montre vibre de nouveau et le clignotement de la petite lumière s'arrête.",
                "buttonSole": "Si cette option est activée, l'unité appel malade permet d'envoyer des alertes en cas d'appui sur le bouton. Pour acquitter l'alerte il faut passer la carte magnétique sur l'unité appel malade.",
                "buttonCau1": "Si cette option est activée, l'unité appel malade permet d'envoyer des alertes en cas d'appui sur le bouton. Pour acquitter l'alerte il faut passer la carte magnétique sur l'unité appel malade.",
                "buttonCau2": "Si cette option est activée, l'unité appel malade permet d'envoyer une demande de renfort.",
                "buttonCall": "Cette option ne peut-être désactivée, le bouton d'alarme du badge mobile GPS permet de lancer un appel depuis le badge vers un numéro pré-configuré.",
                "buttonTmt": "Cette option ne peut-être désactivée, le bouton d'alarme du bouton mobile GPS permet de lancer un sms depuis le bouton vers un numéro pré-configuré.",
                "smoke": "Si cette option est activée, une alerte est automatiquement envoyée lorsque l'équipement détecte de la fumée.",
                "endOfLifeBattery": "Si cette option est activée, une alerte est automatiquement envoyée lorsque le niveau de batterie est critique et que l'appareil est à remplacer.",
                "openDoor": "Si cette option est activée, une alerte est automatiquement envoyée lorsque l'équipement détecte que la porte est ouverte.",
                "dc1": "Si cette option est activée, une alerte est émise si le dispositif détecte un changement d'état.",
                "dc2": "Si cette option est activée, une alerte est émise si le dispositif détecte un changement d'état.",
                "dc3": "Si cette option est activée, une alerte est émise si le dispositif détecte un changement d'état.",
                "dc4": "Si cette option est activée, une alerte est émise si le dispositif détecte un changement d'état.",
                "disconnection": "Si cette option est activée, une alerte est émise si le dispositif ne répond plus.",
                "nonFunctionnal": "Si cette option est activée, une alerte est émise si le dispositif ne répond plus.",
                "prolongedPresence": "Si cette option est activée, une alerte est émise si le dispositif détecte une présence prolongée.",
                "threshold": "Si cette option est activée, une alerte est émise si le dispositif dépasse le seuil configuré.",
                "leak": "Si cette option est activée, une alerte est émise si le dispositif détecte une fuite."
            },
            "DEACTIVATION": {
                "TITLE": "Désactivation de {{name}}",
                "CONTENT": "Êtes-vous sûr(e) de vouloir désactiver l'alerte\u00a0?",
                "POSITION_TRACKING": "Voulez-vous aussi désactiver le suivi de position\u00a0?",
                "ZONE_EXIT": "Attention, l'alerte de sortie de zone utilise le suivi de position pour fonctionner. Confirmez-vous la désactivation du suivi de position et de l'alerte sortie de zone\u00a0?"
            },
            "ACTIVATION": {
                "POSITION_TRACKING_LEGAL": "CO-ASSIST s'engage à préserver l'intégrité et la confidentialité des données de géolocalisation. Membre de la Silver Economy, CO-ASSIST souscrit à la Charte des bonnes pratiques relatives à l'emploi des équipements de géolocalisation en gérontologie au bénéfice des personnes âgées présentant des troubles des fonctions intellectuelles. L'utilisation de la fonctionnalité de géolocalisation de la montre nécessite le consentement préalable libre et éclairé express de l'utilisateur ou d'un aidant ayant tout pouvoir pour agir au nom et pour le compte de l'utilisateur concerné à être géolocalisé. Les données de géolocalisation de l'utilisateur et des aidants sont enregistrées et conservées pendant une durée de deux (2) ans par CO-ASSIST pour les seuls besoins des Services. CO-ASSIST s'engage à mettre tous les moyens en œuvre pour assurer le service. Conformément aux limites établies dans les Conditions Générales et autorisées par la loi, CO-ASSIST ne pourra être tenue pour responsable, à l'égard de l'utilisateur ou des aidants, que si l'utilisateur ou l'aidant concerné a souffert, payé ou subi des dommages directs pouvant être imputés à un défaut des obligations de moyens dans le cadre des Services proposés par CO-ASSIST."
            },
            "ACTION_SUMMARY": {
                "none": "Aucune notification définie",
                "smss": "SMS au {{item}}",
                "emails": "Email à {{item}}",
                "calls": "Appel téléphonique au {{item}}",
                "technicalSmss": "SMS concis au {{item}}",
                "technicalEmails": "Email concis à {{item}}",
                "technicalCalls": "Appel téléphonique concis au {{item}}",
                "processID": "Processus d'appel \"{{item}}\"",
                "webhooks": "Webhook à \"{{item}}\"",
                "whatsApps": "Message WhatsApp à {{item}}",
                "pushNotifications": "Notifier l’application mobile de {{item}}",
                "warning": "ATTENTION : Aucun numéro d'aidant pour les alertes WhatsApp"
            },
            "MISSING_ACTIONS": {
                "TITLE": "Mode de communication manquant",
                "TEXT_SINGLE": "Attention, aucun mode de communication de l'alerte n'a été défini pour l'alerte active suivante\u00a0:",
                "TEXT_PLURAL": "Attention, aucun mode de communication de l'alerte n'a été défini pour les alertes actives suivantes\u00a0:",
                "TEXT_2_SINGLE": "Cette alerte ne sera transmise à personne. Pour définir un mode de communication, cliquer sur la roue crantée correspondant à l'alerte.",
                "TEXT_2_PLURAL": "Ces alertes ne seront transmises à personne. Pour définir un mode de communication, cliquer sur la roue crantée correspondant à chaque alerte."
            },
            "ALERT_SETTING": {
                "LIFE_AREA": "Délimitation de la zone de vie",
                "LATENCY": {
                    "TITLE": "Réactivité de l'alerte",
                    "MIN_LAT_SUBTITLE": "Combien de temps après l'évenement souhaitez-vous être alerté (minimum {{minimumLatency}})\u00a0?",
                    "SUBTITLE": "Combien de temps après l'évenement souhaitez-vous être alerté \u00a0?",
                    "MINIMUM_LATENCY_ERROR": "La réactivité de cette alerte ne peut pas être en dessous de {{minimumLatency}}",
                    "MAXIMUM_LATENCY_ERROR": "La réactivité de cette alerte ne peut pas dépasser {{maximumLatency}}",
                    "NO_DELAY": "Aucun délai",
                    "PLACEHOLDER": "Réactivité de l'alerte"
                },
                "PROBE_PRESENCE": {
                    "TITLE": "Sonde connectée au capteur de température",
                    "BODY": "Afin de réaliser des relevés sur une plus grande plage de température, plus précis et plus réactifs, il est possible de connecter une sonde au capteur de température LHT65N. La sonde est-elle connectée\u00a0?",
                    "PLACEHOLDER": "Présence de la sonde"
                },
                "THRESHOLD": {
                    "TITLE": "Déclenchement sur seuil"
                },
                "BUTTON_PRESS": {
                    "TITLE_WARNING": "Durée de l'appui du bouton. Disponible à partir de la version 2.5",
                    "TITLE": "Durée de l'appui du bouton",
                    "SUBTITLE": "Afin de limiter les appuis intempestifs, il est possible de configurer l'appui du bouton de la montre en \"appui prolongé\". Souhaitez-vous l'activer\u00a0?",
                    "WARNING": "Disponible à partir de la version 2.5",
                    "PLACEHOLDER": "Durée de l'appui",
                    "SHORT": "Court",
                    "LONG": "Prolongé"
                }
            },
            "ALERT_ACTION": {
                "TITLE": "Jeux de notifications",
                "TAB_SETTINGS": "Configuration",
                "TAB_NOTIFICATIONS": "Notifications",
                "TITLE_LIST": "Jeu de notifications",
                "TYPE": {
                    "smss": "Envoyer un SMS",
                    "emails": "Envoyer un Email",
                    "calls": "Passer un Appel",
                    "technicalSmss": "Envoyer un SMS concis",
                    "technicalEmails": "Envoyer un Email concis",
                    "technicalCalls": "Passer un Appel concis",
                    "processID": "Lancer le processus d'appel",
                    "webhooks": "Configurer un webhook",
                    "whatsApps": "Envoyer un message WhatsApp",
                    "pushNotifications": "Notifier l’application mobile"
                },
                "TECHNICAL_FORMAT": {
                    "smss": "<p>Il existe deux types de format pour les sms, un format standard plus verbeux et un format concis plus condensé.</p><br/><p>Format standard : </p><div class='alert alert-success'>Alerte : appui bouton. <br/>Bonjour,<br/>Le bouton d'alerte de la montre portée par (Nom de l'utilisateur) a été appuyé.</div><p>Format concis : </p><div class='alert alert-success'>Alerte: (Type de l'alerte),<br/>Utilisateur: (Nom de l'utilisateur),<br/>userID: (Identifiant de l'utilisateur),<br/>alertID: (Identifiant de l'alerte)</div>",
                    "emails": "<p>Il existe deux types de format pour les emails, un format standard plus verbeux et un format concis plus condensé.</p><br/><p>Format standard : </p><div class='alert alert-success'>Le bouton d'alerte de la montre portée par (Nom de l'utilisateur) a été appuyé.<br/>Pour plus d'information, consultez votre compte sur le site web https://compte.co-assist.fr ou sur l'application mobile.</div><p>Format concis : </p><div class='alert alert-success'>Alerte: (Type de l'alerte),<br/>Utilisateur: (Nom de l'utilisateur),<br/>userID: (Identifiant de l'utilisateur),<br/>alertID: (Identifiant de l'alerte)</div>",
                    "calls": "<p>Il existe deux types de format pour les appels, un format standard plus verbeux et un format concis plus condensé.</p><br/><p>Format standard : </p><div class='alert alert-success'>&laquoBonjour, le bouton d'alerte de la montre porté par (Nom de l'utilisateur) a été appuyé. Pouvez-vous, s'il vous plait, lui porter assistance ?&raquo</div><p>Format concis : </p><div class='alert alert-success'>&laquoAlerte Co-assist. (Type de l'alerte), (Nom de l'utilisateur)&raquo</div>",
                    "webhooks": "<p>Le body standard est du type :<pre>{<br/>type: 'alert',<br/>payload: {<br/>userID: string,<br/>alertID: string,<br/>alertType: string, // ex: 'fall'<br/>alertStatus: string,<br/>startTimeMs: number,<br/>lastStatusUpdateMs: number,<br/>displayName: string}<br/>}<br/></pre></p>",
                    "whatsApps": "<p>Si l'aidant souhaité n'apparait pas, veuillez d'abord lui associer un numéro WhatsApp dans l'onglet \"Aidants et processus\"<p>"
                },
                "ADD_ACTION": "Ajouter une notification",
                "ADD_CONFIGURATION": "Ajouter un jeu de notifications",
                "DELETE_CONFIGURATION": "Supprimer le jeu de notifications sélectionné",
                "COLUMN_TYPE": "Type",
                "COLUMN_VALUE": "Valeur",
                "COLUMN_ACTIONS": "Actions",
                "SELECT_TYPE": "Sélectionner",
                "UNKNOWN_TYPE": "",
                "SELECT_PROCESS": "Sélectionner un processus",
                "SELECT_USERS": "Sélectionner à qui seront envoyées les notificaitons",
                "EMPTY_NOTIFICATIONS": "Vous devez configurer au moins une notification.",
                "ALREADY_HAS_PROCESS": "Un processus d'appel est déjà actif.",
                "INFOS": "<p>Un jeu de notifications est un ensemble de notifications (une ou plusieurs) émises lors d'une alerte.</p><div class='alert alert-success'>Exemple\u00a0: Je peux définir un jeu de notifications nommé &laquo;Matin&raquo; qui correspond à l'envoi d'un mail à &laquo;exemple@co-assist.fr&raquo; et d'un sms à &laquo;0600000000&raquo;.<br>En cas d'alerte je pourrai être notifié comme défini dans le jeu de notifications &laquo;Matin&raquo;.</div><p>Dans le cas de l'utilisation de la planification, il est possible de définir plusieurs jeux de notifications afin d'avoir des notifications différenciées en fonction de la plage horaire (exemple de cas d'usage\u00a0: notifications distinctes jour/nuit, semaine/week-end).</p>"
            }
        },
        "CONFIG_DEVICE": {
            "TITLE": "Configuration de la montre",
            "DESCRIPTION": {
                "realTimeTracker_GH5200": "Cette option ne peut pas être désactivée, la position de l'utilisateur est relevée et transmise lorsque l'utilisateur est en mouvement, à une fréquence préétablie.",
                "realTimeTracker_TMT250": "Cette option ne peut pas être désactivée, la position de l'utilisateur est relevée et transmise lorsque l'utilisateur est en mouvement, à une fréquence préétablie.",
                "realTimeTracker_EV07B": "Cette option ne peut pas être désactivée, la position de l'utilisateur est relevée et transmise lorsque l'utilisateur est en mouvement, à une fréquence préétablie.",
                "timezone": "Cette fonctionnalité permet de régler le fuseau horaire de la montre de l'utilisateur.",
                "display": "Cette fonctionnalité permet de modifier l'affichage de la montre de l'utilisateur.",
                "button_long_pressure": "Cette fonctionnalité permet de modifier la durée d'appui physique du bouton de la montre de l'utilisateur nécessaire pour déclencher une alerte."
            }
        },
        "CONFIG_PROFILE": {
            "ADD": "Ajouter un nouveau profil d'alerte",
            "SET_NAME_TITLE": "Ajout d'un nouveau profil",
            "SET_NAME": "Nom du profil",
            "COPY_PROFILE": "Dupliquer un profil existant",
            "DO_NOT_COPY": "Ne pas dupliquer",
            "DIALOG": {
                "TITLE": "Suppression du profil '{{name}}'",
                "BODY": "Confirmez-vous la suppression ?"
            }
        }
    },
    "POSITION": {
        "GET_HISTORY": "Rechercher",
        "HISTORY_BUTTON": "Position",
        "NONE_POSITION": "Pas de position détectée",
        "POSITION_DATE": "Date de la position\u00a0:",
        "POSITION_ADDRESS": "Adresse de la position\u00a0:",
        "POSITION_ACCURACY": "Précision de la position\u00a0:",
        "VERY_GOOD": "Excellente",
        "GOOD": "Bonne",
        "BAD": "Limitée",
        "ACQUIRED": "Période d'acquisition",
        "FROM": "De",
        "TO": "Jusqu'à",
        "LOAD_MORE": "Charger {{number}} positions supplémentaires"
    },
    "ALERT_DIAGRAM": {
        "TITLE": "Histogramme des alertes"
    },
    "ALERT_HISTORY": {
        "TITLE": "Historique des alertes",
        "SELECT_TITLE": "Depuis",
        "EXPORT_CSV": "Télécharger en CSV",
        "EXPORT_SELECTION_CSV": "Télécharger la sélection en CSV",
        "DETECTED_ALERT": "Des alertes ont été détectées pendant la période sélectionnée",
        "NO_ALERT": "Aucune alerte n'a été détectée pendant la période sélectionnée",
        "ALERT_INFOS": "Vue détaillée de l'alerte {{alertID}}",
        "FILTER_ALL": "Toutes les alertes",
        "COLLECTIVE_ACT": "Qualifier la sélection"
    },
    "POSITION_DASHBOARD": {
        "TITLE": "Dernière position estimée"
    },
    "STATUS": {
        "TITLE": "Alertes ouvertes",
        "DIALOG_INFO": "Une alerte active est une alerte qui n'a pas été annulée,  acquittée, clôturée ou qui n'a pas encore expiré.",
        "STATUS_OK": "Aucune alerte",
        "AUTO_REFRESH": "Rafraîchissement automatique toutes les 30 secondes",
        "DESCRIPTION": {
            "fall.VH2BBUS01": "Le radar de {{displayName}} a détecté une chute.",
            "fall": "Le dispositif de {{displayName}} a détecté une chute.",
            "button": "{{displayName}} a appuyé sur le bouton d'alerte de sa montre.",
            "buttonBracelet": "{{displayName}} a appuyé sur le bouton d'alerte de son bracelet.",
            "buttonSole": "{{displayName}} a appuyé sur le bouton de son appel malade.",
            "buttonCau1": "{{displayName}} a appuyé sur le bouton de son unité appel malade.",
            "buttonCau2": "Du renfort est demandé pour {{displayName}}.",
            "buttonCall": "{{displayName}} a appuyé sur le bouton de son badge mobile GPS.",
            "buttonTmt": "{{displayName}} a appuyé sur le bouton de son bouton mobile GPS.",
            "inactivity": "La montre de {{displayName}} n'a détecté aucun mouvement.",
            "lowBattery": "La batterie de la montre que porte {{displayName}} nécessite d'être rechargée.",
            "criticalBattery": "{{displayName}} n'a plus de batterie sur sa montre.",
            "zoneExit": "{{displayName}} est sorti(e) de la zone définie.",
            "smoke": "Le détecteur de fumée de {{displayName}} a détecté de la fumée.",
            "openDoor": "La porte de {{displayName}} a été ouverte.",
            "dc1": "Le contact sec n°1 de {{displayName}} a déclenché une alerte.",
            "dc2": "Le contact sec n°2 de {{displayName}} a déclenché une alerte.",
            "dc3": "Le contact sec n°3 de {{displayName}} a déclenché une alerte.",
            "dc4": "Le contact sec n°4 de {{displayName}} a déclenché une alerte.",
            "disconnection": "Le radar de {{displayName}} est déconnecté.",
            "nonFunctionnal": "Le dispositif de {{displayName}} est non fonctionnel.",
            "prolongedPresence": "Le radar de {{displayName}} a détecté une présence prolongée.",
            "threshold": "Le seuil  défini du dispositif de {{displayName}} a été dépassé.",
            "leak": "Le dispositif de {{displayName}} a détecté une fuite."
        },
        "ALERTS_HISTORY": "Consulter l'historique d'alertes"
    },
    "SYSTEM_STATUS": {
        "NO_DEVICE": "Pas d'équipement associé",
        "TITLE": "État du service",
        "ACTIVATE_MODULE": "Confirmer la réception de l'équipement",
        "INACTIVE_INFO": "Service désactivé pendant le transport.",
        "DIALOG_INFO": "Une vérification automatique du bon fonctionnement du service est faite quotidiennement afin de garantir une sécurité permanente.",
        "STATUS_OK": "Tout va bien",
        "STATUS_ISSUE": "Deux derniers messages de routine non reçus",
        "STATUS_ISSUE_LAST_HOUR": "Dernier relevé datant de plus d'une heure",
        "MOUSEOVER_TEXT": "Placer votre montre sur la borne de recharge",
        "STATUS_WARNING": "Dernier message de routine non reçu",
        "STATUS_UNKNOWN": "Pas d'information sur l'état du service",
        "LAST_UPDATE_TITLE": "Dernier relevé",
        "LAST_UPDATE": "Le dernier message a été reçu le {{date}}",
        "BATTERY_TITLE": "Niveau de batterie",
        "CONNECTIVITY_TITLE": "Connectivité",
        "UPDATE_TITLE": "Mise à jour des paramètres",
        "WATCH_UP_TO_DATE": "Les paramètres de la montre sont à jour",
        "WATCH_NOT_UP_TO_DATE": "Après validation de votre configuration, veuillez poser votre montre sur le chargeur pour la synchroniser"
    },
    "PROFILE": {
        "TITLE": "Profil de {{name}}",
        "UPDATE_SUCCESS": "Vos modifications ont bien été enregistrées",
        "MY_GROUP": {
            "TITLE": "Mon établissement",
            "GROUP_ID": "Identifiant de l'établissement",
            "GROUP_NAME": "Nom de l'établissement",
            "GROUP_ADDRESS": "Adresse de l'établissement",
            "IVR_EXPRESSION": "Configuration SVI",
            "IVR_EXPRESSION_DIALOG": {
                "TITLE": "Configuration SVI (Serveur Vocal Interactif)",
                "WARNING": "Une modification de la configuration SVI impactera la chaîne d'alerte.",
                "MORE_INFO": "Pour plus d'informations merci de contacter notre service client au 02 78 34 04 51.",
                "ACTIONS_TITLE": "Actions effectués sur le SVI",
                "ACTIONS": {
                    "play": "Saisir {{value}}",
                    "pause": "Attendre {{value}}",
                    "END": "Début du message d'alerte."
                },
                "THEN": " puis ",
                "USER_EXT": "l'extension de l'aidant",
                "INVALID_EXPRESSION": "La configuration n'est pas valide",
                "ERROR_TOO_LONG": "Le temps total d'attente ne peut pas dépasser {{maxLength}} secondes",
                "ERROR_TOO_MUCH_ACTIONS": "La configuration ne peut pas dépasser {{maxLength}} actions"
            },
            "IVR_EXPRESSION_RESET_DIALOG": {
                "TITLE": "Réinitialiser la configuration SVI",
                "TEXT": "Souhaitez-vous rétablir la configuration par défaut ?"
            },
            "IVR_EXPRESSION_HELP_DIALOG": {
                "TITLE": "Configuration SVI",
                "TEXT": "La configuration SVI permet de créer une suite d'actions qui seront réalisées lorsque un appel est effectué sur un PBX afin d'atteindre un aidant suivant son extension.<br>Chaque serveur vocal pouvant être différent, il peut être nécessaire de créer une suite d'actions spécifiques.<br><br>La suite d'actions se termine automatiquement par le début du message d'alerte <b>\"Bonjour ici le service d'alerte Co-assist ....\"</b>.<br><br>Syntaxe pour la configuration SVI :<br>- chaque action est séparée par un tiret <b>-</b><br>- attendre x seconde(s) : nombre supérieur ou égal à <b>1</b><br>- saisir une ou plusieurs touches : <b>[*</b> ou <b>#</b> ou chiffre de <b>0</b> à <b>9]</b><br>- saisir l'extension de l'aidant à contacter : <b>H</b><br><br>Exemple : <b>1-[#0]-3-H-2</b><br><br>Comportement par défaut : <span class=\"actions\">Attendre 1 seconde</span> puis <span class=\"actions\">Saisir l'extension de l'aidant</span> puis <span class=\"actions\">Attendre 1 secondes</span> puis <span class=\"actions\">Début du message d'alerte</span>."
            }
        },
        "FURTHER_INFORMATION": {
            "CONFIRM_DELETE_TITLE": "Suppression de l'information sélectionnée",
            "CONFIRM_DELETE_TEXT": "Êtes-vous sûr de vouloir supprimer cette information de la liste\u00a0?",
            "TITLE": "Informations à communiquer aux aidants",
            "SUBTITLE": "Vous pouvez inscrire ici les informations qui seront accessibles aux aidants (exemple\u00a0: date de naissance, code d'entrée, étage, lieu de cachette de la clé, numéro de téléphone du/de la gardien(ne), numéro d'un voisin, numéro d'un médecin, données médicales, groupe sanguin, etc.).",
            "DIALOG_INFO": "Ces informations sont strictement confidentielles, l'utilisateur reste le seul responsable des informations qu'il diffuse.",
            "ADD_INFORMATIONS": "Ajouter ces informations",
            "EMPTY_INFORMATIONS": "Pas de donnée enregistrée",
            "TABLE": {
                "INFORMATION": "Information",
                "DESCRIPTION": "Description"
            }
        },
        "NEW_PASSWORD": {
            "TITLE": "Mot de passe",
            "TOAST": {
                "EMAIL_PASSWORD": "Vous allez recevoir un email de confirmation"
            }
        },
        "UPDATE_LOGIN_ID": {
            "TITLE": "Mettre à jour mon identifiant de connexion",
            "ALREADY_TAKEN": "L'identifiant {{loginID}} n'est pas disponible",
            "INVALID": "L'identifiant {{loginID}} n'est pas valide"
        }
    },
    "TIMEZONE": {
        "LABEL": "Fuseau horaire",
        "FILTER": "Sélectionnez votre fuseau horaire",
        "EMPTY": "Aucune correspondance trouvée"
    },
    "MAP": {
        "CENTER": "centre",
        "HOME": "Domicile"
    },
    "BATTERY": {
        "TITLE": "Niveau de la batterie",
        "UNKNOWN_BATTERY": "Niveau de batterie inconnu",
        "THRESHOLD_LOW": {
            "TITLE": "Faible {{lvl}}\u00a0%",
            "SUBTITLE": "Le niveau de batterie est insuffisant, pensez à recharger la montre, relevé effectué le {{date}}"
        },
        "THRESHOLD_MID": {
            "TITLE": "Bon {{lvl}}\u00a0%",
            "SUBTITLE": "Le niveau de batterie est suffisant, relevé effectué le {{date}}"
        },
        "THRESHOLD_HIGH": {
            "TITLE": "Très bon {{lvl}}\u00a0%",
            "SUBTITLE": "Le niveau de batterie est suffisant, relevé effectué le {{date}}"
        }
    },
    "SYSTEM_STATE": {
        "TITLE": "État du service",
        "OK": {
            "TITLE": "Service fonctionnel",
            "SUBTITLE": "Il n'y a aucun problème détecté"
        },
        "BAD": {
            "TITLE": "Service non fonctionnel",
            "SUBTITLE": "Un problème a été detecté"
        }
    },
    "LANGUAGE_PREFERENCES": {
        "TITLE": "Préférence de langue de",
        "LANGUAGE": "Langue de",
        "DEFAULT_LANGUAGE_HELPED": "Langue du service d'alerte de",
        "UPDATE_SUCCESS": "Vos modifications ont bien été enregistrées"
    },
    "EMAIL_CHECKER": {
        "ACCOUNT_ACTIVATED": "Votre compte est activé.",
        "CAN_SIGNIN": "Vous pouvez dès à présent vous connecter."
    },
    "LOGIN": {
        "SUBSCRIBE": "Souscrire",
        "FORM_TITLE": "Se connecter",
        "PASSWORD_PLACEHOLDER": "Mot de passe",
        "FORGOT_PASSWORD_LINK": "Mot de passe oublié\u00a0?",
        "LOGIN_BUTTON": "Se connecter",
        "OTP_PASSWORD": "Code MFA",
        "OTP_ERROR": "Le code MFA est incorrect",
        "OTP_MUST_BE_SUPPLIED": "Veuillez saisir le code MFA",
        "PASSWORD_TOO_OLD": "Votre mot de passe est trop ancien. Vous devez le renouveler.",
        "LOGIN_FAILURE": "Identifiant ou mot de passe incorrect.",
        "LOGIN_BLOCKED": "Toute tentative de connexion est bloquée pour {{arg}} minutes",
        "REMAINING_ATTEMPT": "Attention, il vous reste {{arg}} essai avant que la connexion soit bloquée",
        "REMAINING_ATTEMPTS": "Attention, il vous reste {{arg}} essais avant que la connexion soit bloquée",
        "MISSING_VERIFICATION": "Veuillez confimer votre compte, en cliquant ici.",
        "NOT_REGISTERED": "Aucun compte existant"
    },
    "REGISTRATION": {
        "FORM": {
            "CIVILITY": "Le champ civilité est obligatoire",
            "NAME": "Le champ nom est obligatoire",
            "LAST_NAME": "Le champ nom est obligatoire",
            "FIRST_NAME": "Le champ prénom est obligatoire",
            "EMAIL": "Le champ email doit être une adresse valable",
            "PASSWORD": "Le champ mot de passe est obligatoire",
            "CONFIRM_PASSWORD": "Les champs mot de passe et confirmation doivent correspondre",
            "PASSWORD_LENGTH": "Le mot de passe doit faire au minimum 5 caractères",
            "PHONE_NUMBER": "Le champ numéro de téléphone est obligatoire",
            "PHONE_NUMBER_FORMAT": "Ce numéro n'est pas valide",
            "ADDRESS": "Le champ adresse est obligatoire",
            "TIMEZONE": "Le fuseau horaire est obligatoire",
            "LANGUAGE": "Le champ langue est obligatoire",
            "DELIVERY_ADDRESS": "Adresse de livraison",
            "ADDRESS_RADIO": "Le champ 'Est-ce l'adresse de livraison\u00a0?' est obligatoire",
            "FIELD_MANDATORY": "Le champ '{{fieldName}}' est obligatoire",
            "INVALID_CARD_NUMBER": "Ce numéro de carte bancaire est invalide",
            "INVALID_CODE_NUMBER": "Ce CVC est invalide",
            "INVALID_EXPIRY_DATE": "Cette date d'expiration est invalide"
        },
        "STEP": {
            "NETWORK_CHECK": {
                "TITLE": "Vérification du réseau",
                "FIRST_QUESTION": "Le domicile de l'utilisateur est-il correctement couvert\u00a0?",
                "UNKNOWN_ADDRESS": "Vous ne trouvez pas votre adresse ? Essayez avec le code postal ou contactez-nous au",
                "INFO": "La couverture du domicile dépend de sa configuration (étage, norme de construction, murs épais)",
                "TAX": "Tous les prix indiqués sont éligibles au crédit d'impôts de 50%",
                "ACTION": "Vérifier le réseau",
                "OUTDOOR_TITLE": "En extérieur",
                "OUTDOOR_COVERAGE": {
                    "OK": "le réseau est suffisant en extérieur pour le bon fonctionnement de la montre.",
                    "WEAK": "le réseau est limité à l'extérieur. L'utilisation de la montre en extérieur est déconseillée car certaines alertes pourraient ne pas être transmises.",
                    "KO": "le réseau en place ne permet pas l'utilisation de la montre en extérieur."
                },
                "INDOOR_TITLE": "En intérieur",
                "INDOOR_COVERAGE": {
                    "OK": "le réseau est suffisant en intérieur pour le bon fonctionnement de la montre.",
                    "WEAK": "le réseau est insuffisant en intérieur pour le bon fonctionnement de la montre. L'installation d'un répéteur au domicile est requise. Le répéteur ne permet pas d'améliorer le réseau en extérieur.",
                    "KO": "le réseau en place ne permet pas l'utilisation de la montre à l'intérieur. Pour assurer le fonctionnement, l'installation d'une antenne au domicile est requise. L'antenne permet de couvrir le domicile et le jardin le cas échéant. L'installation de l'antenne nécessite une connexion internet filaire et une prise de courant. L'antenne ne permet pas d'améliorer le réseau en extérieur."
                },
                "CONTACT_CUSTOMER_SERVICE": "En cas de doute, contactez le service client via le chat ou par téléphone au {{phoneNumber}}",
                "TIPS": {
                    "repeater": "Un répéteur amplifie le signal ; un accès au réseau, même faible, est nécessaire.",
                    "antenna": "Une antenne crée son propre signal à partir d'une connection internet (3G ou Ethernet), ce qui permet l'émission des alertes même avec un réseau inexistant."
                },
                "LINK_TITLE": "[fiche technique]",
                "LINK": {
                    "repeater": "https://hubs.ly/H0mzxjK0",
                    "antenna": "https://hubs.ly/H0mzxSf0"
                },
                "SELECT_OPTION": "Je sélectionne mon option",
                "SHIPPING_INFO": "{{price}}\u00a0€ de frais d'expédition.",
                "OPTIONS": {
                    "renting": "Location",
                    "purchase": "Achat",
                    "none": "Aucune option",
                    "repeater": "Répéteur",
                    "antenna": "Antenne",
                    "renting_price": "{{price}}\u00a0€\u00a0/\u00a0mois",
                    "purchase_price": "{{price}}\u00a0€",
                    "renting_repeater": "Je loue un répéteur ({{price}}\u00a0€\u00a0/\u00a0mois)",
                    "purchase_repeater": "J'achète un répéteur ({{price}}\u00a0€)",
                    "renting_antenna": "Je loue une antenne ({{price}}\u00a0€\u00a0/\u00a0mois)",
                    "purchase_antenna": "J'achète une antenne ({{price}}\u00a0€)"
                }
            },
            "PERSONALIZE": {
                "TITLE": "Personnalisation",
                "FIRST_QUESTION": "Êtes-vous déjà en possession de la montre d'alerte Co-assist\u00a0?",
                "WATCH_OWNER": "Je possède déjà la montre",
                "WATCH_NOT_OWNER": "Je n'ai pas encore de montre",
                "IDENTIFICATION_NUMBER_TITLE": "Quel est le numéro d'identification de la montre\u00a0?",
                "IDENTIFICATION_NUMBER": "Numéro d'identification de la montre",
                "IDENTIFICATION_NUMBER_HELPER": "Le numéro d'identification se situe sur le courrier de bienvenue",
                "INVALID_IDENTIFICATION_NUMBER": "Ce numéro d'identification est incorrect",
                "SELECT_PROCESS": "Qui doit être contacté en cas d’alerte ?",
                "EMBEDDED": "Mes proches",
                "TELECARE": "Un plateau d’écoute professionnel",
                "TELECARE_PRICE": "Supplément 10€ / mois (5€ après crédit d’impôt)",
                "SELECT_ITEM": "Je choisis mon accessoire",
                "SELECT_DISPLAY": "Quel affichage souhaitez-vous\u00a0?",
                "WATCH_DISPLAY": "Affichage de l'heure",
                "WATCH_NUMERIC": "Numérique",
                "WATCH_NUMERIC_DDMM": "Numérique avec date",
                "WATCH_HANDS": "Analogique"
            },
            "ACCOUNT_CREATION": {
                "TITLE": "Création du compte",
                "FIRST_QUESTION": "Êtes-vous l'utilisateur de la montre (celui qui la portera)\u00a0?",
                "WATCH_HELPED": "Je suis l'utilisateur",
                "WATCH_HELPER": "Je ne suis pas l'utilisateur",
                "YOUR_ACCOUNT": "Votre compte",
                "USER_ACCOUNT": "Le compte de l'utilisateur",
                "DELIVERY_ADDRESS": "Est-ce l'adresse de livraison\u00a0?",
                "RECIPIENT_ADDRESS": "Adresse d'envoi",
                "RECIPIENT_FIRSTNAME": "Prénom du destinataire",
                "RECIPIENT_LASTNAME": "Nom du destinataire",
                "AUTO_GENERATED": "M'envoyer un mot de passe aléatoire",
                "PASSWORD": "Mot de passe",
                "CONFIRM_PASSWORD": "Confirmation du mot de passe"
            },
            "PAYMENT": {
                "TITLE": "Valider la commande",
                "SECURE_PAYMENT": "Paiement 100% sécurisé",
                "CART": "Récapitulatif",
                "ADDITIONAL_INFO": "Informations supplémentaires (détails pour la livraison, etc.)",
                "CONFIRM_ORDER": "Valider la commande",
                "TOTAL_AMOUNT": "Montant à payer",
                "FIRST_DEBIT": "Premier prélèvement",
                "CB": {
                    "NAME": "Paiement par carte bancaire"
                },
                "SEPA": {
                    "NAME": "Paiement par prélèvement SEPA",
                    "FIRST_NAME": "Prénom du titulaire",
                    "LAST_NAME": "Nom du titulaire",
                    "ADDRESS": "Adresse du titulaire",
                    "IBAN": "Numéro IBAN",
                    "IBAN_INVALID": "Cet IBAN est invalide",
                    "ADDRESS_INVALID": "L'adresse saisie est invalide"
                },
                "MAKE_PAYMENT_CHOICE": "Sélectionnez votre moyen de paiement",
                "CHECKBOX": {
                    "GENERAL_CONDITIONS": "Je reconnais expressément avoir pris connaissance et accepter sans réserve les Conditions Générales de CO-ASSIST SERVICES.",
                    "DEBIT": "J'accepte que mon compte bancaire soit débité automatiquement des frais mentionnés ci-dessus.",
                    "CONSENT": "J'accepte que mes informations personnelles soient utilisées pour l'exécution du contrat par CO-ASSIST SERVICES pendant toute sa durée et certifie avoir eu le consentement des personnes mentionnées pour le partage de leurs données personnelles.",
                    "TAX_CREDIT": "Je déclare que la solution de CO-ASSIST SERVICES servira exclusivement au maintien à domicile d'une personne âgée ou handicapée.",
                    "TAX_CREDIT_NOTE": "Cette dernière condition est nécessaire pour bénéficier du crédit d'impôts lié aux services à la personne. Si ce n'est pas votre cas, ",
                    "CONDITIONS_MANDATORY": "La validation des conditions ci-dessus est obligatoire",
                    "CONTACT": "contactez-nous"
                },
                "PERSONAL_DATA": "Co-assist collecte les données personnelles de ce formulaire afin de gérer votre contrat. En application de la loi n\u00a0°\u00a078-17 du 6 janvier 1978 modifiée le 20 juin 2018 et du règlement européen 2016/679 du 27 avril 2016, vous disposez des droits d'opposition, d'accès, de rectification, d'oubli et de portabilité des données vous concernant, ainsi que la limitation des finalités. Nous conservons vos données jusqu'à la fin de votre contrat. Pour plus d'informations, consultez notre politique de confidentialité. Pour exercer ces droits, contactez-nous à l'adresse suivante\u00a0:",
                "ALREADY_OWN_WATCH": {
                    "TITLE": "Souhaitez-vous entrer vos informations de paiement maintenant ?",
                    "DIALOG": {
                        "TITLE": "Confirmation de la création du compte",
                        "CONTENT": "Vous êtes sur le point de valider la création de votre compte sans indiquer vos informations de paiement, vous pourrez entrer ces informations plus tard."
                    }
                },
                "IS_ACQUERING_WATCH": {
                    "TITLE": "Quelle option tarifaire voulez-vous\u00a0?",
                    "NOT_METROPOLITAN": "Si vous n'êtes pas situé en France métropolitaine, contactez-nous pour connaître nos offres."
                },
                "liberty": {
                    "TITLE": "Formule Liberté",
                    "SUBTITLE": "Louez la montre avec son service d'alerte pour plus de flexibilité",
                    "PRICING": "44,99€\u00a0/\u00a0mois"
                },
                "economy": {
                    "TITLE": "Formule Économie",
                    "SUBTITLE": "Acheter la montre pour un usage économique",
                    "PRICING": "269,99€"
                },
                "saved": {
                    "TITLE": "Je sauvegarde",
                    "SUBTITLE": "Je serai débité automatiquement dans 6 mois",
                    "PRICING": "0,01€"
                },
                "none": {
                    "TITLE": "Plus tard",
                    "SUBTITLE": "J'entrerai mes informations de paiement plus tard",
                    "PRICING": "0€"
                },
                "DESCRIPTION": {
                    "FEE": "79€ de frais de configuration de la montre, formation à son utilisation et expédition",
                    "ECONOMY_CREDIT_TAX": "134,99€ après crédit d’impôt (50%)",
                    "LIBERTY_CREDIT_TAX": "22,49€ après crédit d’impôt (50%)",
                    "WATCH_RENT": "Montre en location (caution non encaissée de 240€ TTC)",
                    "NO_ENGAGEMENT": "Pas d’engagement",
                    "ECONOMY_NO_ENGAGEMENT": "Pas d’engagement et deux semaines pour tester la solution et la renvoyer si elle ne convenait pas",
                    "ALL_FUNCTIONNALITIES": "Toutes les fonctionnalités disponibles",
                    "ECONOMY_MONTHLY": "Abonnement de 29,99€ / mois (premier mois inclus) soit 14,99€ après crédit d’impôt (50%)",
                    "ONE_MONTH": "Un mois d’abonnement inclus puis 29,99€\u00a0/\u00a0mois",
                    "SIX_MONTH": "Six mois d’abonnement inclus puis 15€\u00a0/\u00a0mois",
                    "CONTINUITY": "Aucune coupure de service au bout de 6 mois",
                    "TAX_CREDIT": "Crédit d’impôt de 50%",
                    "RENTING": "Montre en location",
                    "TWO_WEEKS_TO_TEST": "Deux semaines pour tester la solution et la renvoyer si elle ne convenait pas"
                },
                "DISCOUNT": {
                    "LABEL": "Code promotionnel"
                },
                "DIALOG_RECOVER_DATA": {
                    "TITLE": "Souhaitez-vous charger votre ancien formulaire\u00a0?",
                    "MESSAGE": "Votre ancien formulaire a été sauvegardé, souhaitez-vous reprendre où vous vous étiez arrêté(e)\u00a0?"
                },
                "DIALOG_PAYMENT": {
                    "SUCCESS_PAYMENT": "Félicitations, votre paiement a été enregistré",
                    "SUCCESS": "Félicitations, vous pouvez à présent vous connecter",
                    "3D_SECURE": "Votre paiement doit être vérifié, vous allez être redirigé vers votre banque",
                    "REDIRECT_PAYMENT_PAGE": "Retourner à la page de commande",
                    "CLOSE": "Fermer",
                    "ERROR": {
                        "TITLE": "Une erreur est survenue",
                        "MESSAGE": "Vous n'avez pas été débité, vous pouvez essayer de renouveler votre paiement",
                        "INVALID_PAYMENT_DATA": "Vos données de paiement sont incorrectes"
                    }
                },
                "RESULT": {
                    "SUCCESS": "Votre transaction a été validée",
                    "FAILURE": "Votre transaction n'a pas été validée"
                },
                "MENSUAL_DEBIT": "{{price}}\u00a0{{currency}} par mois",
                "MENSUAL_FEES": "Abonnement mensuel au service à partir du {{date}}",
                "PRODUCT": "Produit",
                "FEE": "Configuration de la montre, formation et expédition",
                "WATCH": "Montre",
                "REPEATER": "Répéteur",
                "ANTENNA": "Antenne",
                "DELIVERY": "Livraison",
                "SUB_TOTAL": "Sous-total",
                "TOTAL": "Total à payer",
                "RENTING": "Location mensuelle",
                "SERVICETELECARE": "Abonnement mensuel au service de téléassistance",
                "SUBSCRIPTION": {
                    "MONTHLY": "Frais mensuels montre + service",
                    "economy": "“Option économie”",
                    "liberty": "“Option liberté”",
                    "saved": "",
                    "NONE": ""
                }
            }
        },
        "WATCH_DIALOG": {
            "TITLE": "Choix de la taille du bracelet",
            "SUBTITLE": "Vous pouvez recevoir votre bracelet à la taille souhaitée en nous précisant ci-dessous la taille en centimètres. Si vous ne connaissez pas la taille, choisissez la plus grande taille et vous pourrez découper le bracelet chez vous.",
            "WATCHBAND_SIZE": "Votre tour de poignet en cm\u00a0:"
        },
        "TITLE": "Inscription",
        "CUSTOMER_SERVICE": "Service client\u00a0:",
        "CUSTOMER_SERVICE_NUMBER": "02\u00a078\u00a034\u00a004\u00a051",
        "GET_BOOKLET": "Recevoir une brochure",
        "LEGAL_INFO": "Mentions légales - Conditions Générales de Ventes",
        "PAYMENT": {
            "TITLE": "Paiement",
            "SAVE_PAYMENT_INFOS": "J'entre mes informations de paiement",
            "CARD_NUMBER": "Numéro de carte",
            "CARD_OWNER": "Titulaire de la carte",
            "EXPIRATION_MONTH": "Mois",
            "EXPIRATION_YEAR": "Année",
            "CODE": "CVC",
            "INFO_CODE": "Un cryptogramme visuel de carte est une série unique de trois chiffres imprimée sur la carte de crédit. Vous le trouverez au dos des cartes bancaires Visa et MasterCard."
        },
        "CARRIER": {
            "EMAIL": "Email (celui de l'utilisateur de la montre ou celui d'un proche)"
        },
        "ERROR": {
            "CIVILITY": "Veuillez renseigner le champ Civilité",
            "EMAIL": "Le champ Email n'est pas valide, veuillez réitérer",
            "TEL": "Le champ Téléphone n'est pas valide, veuillez réitérer"
        }
    },
    "CONTENT": {
        "NAVBAR": {
            "SELECT_USER": "Utilisateur...",
            "DASHBOARD": "Tableau de bord",
            "ALERTS_CONF": "Configuration des alertes",
            "ACTIONS": "Aidants et processus",
            "RECORDS": "Relevés",
            "ACTIVITY": "Activité",
            "DOOR": "Porte",
            "TEMPERATURE": "Température",
            "PROFILE": "Profil de l'utilisateur",
            "CONTRACT": "Contrat de l'utilisateur",
            "ADMINISTRATION": "Administration",
            "DASHBOARD_B2B": "Tableau de bord général",
            "GROUP_ASSOCIATIONS": "Association équipement/utilisateur",
            "ALERT_PROCESS_MANAGEMENT": "Configuration des profils d'alerte",
            "DEVICE_LOCATION": "Localisation",
            "MY_PROFILE": "Mon profil",
            "MY_CONTRACT": "Mon contrat"
        },
        "MORE": "Plus",
        "LANGUAGE": "Langage",
        "APPLICATION": "Choix du service",
        "SETTINGS": "Paramètres",
        "LOGOUT": "Déconnexion",
        "HELP": "Assistance",
        "FAQ": "Centre d'aide",
        "RELEASE_NOTE": "Nouveautés",
        "STATUS_PAGE": "Etat des services"
    },
    "CONTRACT": {
        "MY_CONTRACT": {
            "TITLE": "Contrat",
            "ASK_SUBSCRIPTION": "Ma demande d'abonnement",
            "CGS": "Conditions générales de service",
            "UNSUBSCRIBE": "Résilier le contrat",
            "TOAST": {
                "ERROR": "Fichier non existant"
            }
        },
        "PAYMENT": {
            "TITLE": "Moyens de paiements",
            "SUBSCRIPTION": "Abonnement souscrit\u00a0:",
            "OPTIONS": "Option(s) souscrite(s)\u00a0:",
            "SUBSCRIPTION_SERVICE_START_DATE": "à partir du {{date}}",
            "SUBSCRIPTION_STATE": "Status de l'abonnement\u00a0:",
            "SUBSCRIPTION_INACTIVE": "en attente de validation",
            "SUBSCRIPTION_DATE": "Date d'abonnement\u00a0:",
            "NEXT_PAYMENT_DATE": "Prochain prélèvement\u00a0:",
            "NEXT_PAYMENT_DETAIL": "{{price}}\u00a0{{currency}} le {{date}}",
            "NOT_AN_ONLINE_SUBSCRIPTION": "Vous n'avez pas souscrit en ligne",
            "EDIT_PAYMENT_METHOD": "Remplacer mon moyen de paiement",
            "VALIDATE_PAYMENT_METHOD": "Valider mon moyen de paiement"
        },
        "BILLS": {
            "TITLE": "Factures",
            "TYPE": {
                "invoice": "Facture de {{total}} du {{createdAt}}",
                "creditNote": "Facture d'avoir de {{total}} du {{createdAt}}"
            },
            "DOWNLOAD_BILL": "Télécharger la facture",
            "ASK_BILL": "Demander une facture pour cette période",
            "NO_INVOICES": "Pas de facture disponible sur cette période",
            "GET_MAIL_INVOICE": "Je souhaite recevoir un email à chaque nouvelle facture",
            "BILLING_YEAR": "Année de facturation",
            "TOAST": {
                "ERROR": "Échec de la récupération de la facture"
            }
        },
        "TAX": {
            "TITLE": "Attestations fiscales",
            "DOWNLOAD_TAX": "Demander une attestation fiscale",
            "SELECT_YEAR": "Choisissez une année",
            "TOAST": {
                "ERROR": "Aucune attestation existante pour l'année choisie"
            }
        },
        "UNSUBSCRIBE": {
            "TITLE": "Résilier le contrat de {{helpedName}}",
            "TEXT": {
                "SORRY": "Nous sommes navrés que vous résiliez votre contrat avec Co-assist.",
                "DEACTIVATION": "Comme stipulé dans nos conditions générales, après résiliation le matériel sera désactivé et vous ne pourrez plus l'utiliser.",
                "RETURN_ADDRESS": "Si vous n'avez pas acheté la montre, vous disposez d'un délai de 30 jours pour nous faire parvenir la montre et son chargeur complet à l'adresse <strong>CO-ASSIST, 77 rue Michelet, 76600 Le Havre</strong>, sans quoi nous débiterons 190\u00a0€ sur le compte en banque qui sert au paiement. Co-assist s'engage à recycler ses produits."
            },
            "WHY": "Pour quelles raisons souhaitez-vous résilier votre contrat avec Co-assist\u00a0?*",
            "IMPROVE": "Souhaitez-vous nous laisser un commentaire afin d'améliorer notre service\u00a0?",
            "RAISON_TWO": "Décès",
            "RAISON_ONE": "Départ en EHPAD",
            "RAISON_THREE": "Changement de domicile",
            "RAISON_FOUR": "Non satisfaction du service de détection de chute",
            "RAISON_FIVE": "Non satisfaction du service de détection de suivi de position",
            "RAISON_SIX": "Non couvert par le réseau",
            "RAISON_SEVEN": "Autre\u00a0: préciser en commentaires",
            "TOAST": {
                "ERROR": "Échec de la résiliation",
                "SUCCESS": "Contrat résilié"
            }
        }
    },
    "POSITION_TRACKING": {
        "TITLE": "Suivi de position",
        "CAUTION_TRACKING_DEACTIVATE": "Attention\u00a0: pour fonctionner, le suivi de position doit être activé"
    },
    "CSV_HEADER": {
        "FILE_NAME": "Historique d'alerte de",
        "ALERT": "Alerte",
        "USERID": "Identifiant",
        "DEVICE_TYPE": "Type de dispositif",
        "NAME": "Nom",
        "ALERT_ID": "AlertID",
        "MODULEID": "moduleID",
        "ALERT_TYPE": "Type d'alerte",
        "ALERT_DATE": "Date de début",
        "ALERT_TIME": "Heure de début",
        "ALERT_HANDLE_TIME": "Durée avant prise en charge",
        "ALERT_HANDLE_TIME_IN_SEC": "Durée avant prise en charge [sec]",
        "ALERT_HANDLE_DATE": "Heure de prise en charge",
        "ALERT_HANDLER": "A pris en charge",
        "ALERT_INTERRUPT_TIME": "Durée avant interruption",
        "ALERT_INTERRUPT_TIME_IN_SEC": "Durée avant interruption [sec]",
        "ALERT_INTERRUPT_DATE": "Heure d'interruption",
        "ALERT_ACQUIT_TIME": "Durée avant l'acquittement",
        "ALERT_ACQUIT_TIME_IN_SEC": "Durée avant acquittement [sec]",
        "ALERT_ACQUIT_DATE": "Heure d'acquittement",
        "ALERT_ACQUITTED_BY": "Méthode d'acquittement",
        "ALERT_ACQUITTER": "A acquitté",
        "QUALIFICATION": "Qualification de l'évènement",
        "COMMENT": "Observations"
    },
    "DISCOUNT_CODE": {
        "PROMOTIONAL_CODE": "Code promotionnel",
        "VALIDATE_CODE": "Appliquer le code",
        "TOAST": {
            "VALID_CODE": "Le code saisi a été appliqué",
            "INVALID_CODE": "Le code saisi n'est pas valable"
        }
    },
    "USER_AUTOCOMPLETION": {
        "ERROR": "Vous devez saisir un utilisateur valide"
    },
    "SUBSCRIPTION": {
        "saved": "Service",
        "none": "Aucun",
        "none-unsubscribe": "En attente de retour pour résiliation",
        "none-waiting": "En attente de validation pour souscription",
        "none-partner": "Contrat partenaire",
        "liberty": "Liberté",
        "liberty-repeater": "Liberté avec location d'un répéteur",
        "liberty-antenna": "Liberté avec location d'une antenne",
        "liberty-reunion": "Liberté (île de la Réunion)",
        "economy": "Economie",
        "economy-repeater": "Economie avec location d'un répéteur",
        "economy-antenna": "Economie avec location d'une antenne"
    },
    "OPTION": {
        "RENTANTENNA": "Location Antenne",
        "RENTREPEATER": "Location Répéteur",
        "RENTREPEATER2": "Location répéteur",
        "SERVICETELECARE": "Plateau d'écoute"
    },
    "USER_OVERVIEW": {
        "TITLE": "Administration",
        "CURRENTLY_LOGGED_IN_AS": "Actuellement sur le compte de",
        "SEARCH_BUTTON": "Rechercher",
        "ACTIONS": {
            "LOG_OUT": "Se déconnecter",
            "OPEN_BACK_OFFICE": "Ouvrir l'ERP",
            "LOGOUT_ACTUAL_USER": "Se déconnecter de l'utilisateur actuel"
        },
        "ERROR": {
            "NO_USER": "Utilisateur inexistant"
        }
    },
    "PRIVACY": {
        "POSITION": {
            "TITLE": "Accès à l'historique des positions",
            "DESCRIPTION": "Selon le règlement général sur la protection des données (RGPD), l'accès aux données de localisation doit être justifié par une demande d'intervention de la part de l'utilisateur ou par une situation d'urgence nécessitant de connaître sa position.",
            "CONFIRMATION": "Confirmez-vous être dans l'un de ces deux cas\u00a0?"
        },
        "GDPR": {
            "MANAGE": "Gérer mes données personnelles",
            "TITLE": "Données personnelles",
            "DESCRIPTION": "Je souhaite ",
            "CHOICE": "{{action}}",
            "CHOICES": {
                "read": "exercer mon droit de consultation",
                "update": "exercer mon droit de rectification",
                "delete": "exercer mon droit de suppression",
                "violation": "déclarer une violation de mes données"
            },
            "COMMENTARY": "Préciser les données concernées (ex : historique d'alerte)"
        }
    },
    "ACTIVITY": {
        "TITLE": "Suivi d'activité du porteur de la montre",
        "SHORT_TITLE": "Suivi d'activité",
        "SERIE": "Mesure d'activité",
        "AVERAGE": {
            "LABEL": "Moyenne",
            "LEGEND": "Activité moyenne de la période"
        },
        "RECOMMENDED": {
            "LABEL": "Recommandée",
            "LEGEND": "Activité minimale recommandée par Co-assist"
        },
        "WHO": {
            "LINK": "Recommandations de l'Organisation mondiale de la Santé sur l'activité physique",
            "CONTENT": "<strong>Recommandations OMS</strong><br><br><I>Les personnes âgées devraient pratiquer au moins, au cours de la semaine, 150 minutes d’activité d’endurance d’intensité modérée.<br>L’activité d’endurance devrait être pratiquée par périodes d’au moins 10 minutes.</I><br><br><a href=\"https://www.who.int/dietphysicalactivity/factsheet_olderadults/fr/\">Plus d'informations</a>"
        },
        "MISSING_DATA": "Pas assez de données disponibles",
        "NO_DATA": "Pas de données"
    },
    "TEMPERATURE": {
        "TITLE": "Température ambiante",
        "ALERT_THRESHOLD": "Seuil d'alerte",
        "CHECKING": "Surveillance de la température",
        "SHORT_TITLE": "Température ambiante",
        "MIN": {
            "LABEL": "19°C",
            "LEGEND": "Température minimale recommandée"
        },
        "MAX": {
            "LABEL": "32°C",
            "LEGEND": "Température maximale recommandée"
        },
        "SERIE": "Température",
        "MISSING_DATA": "Pas assez de données disponibles",
        "NO_DATA": "Pas de données",
        "WHO": {
            "LINK": "Recommandations de l'Organisation mondiale de la Santé",
            "CONTENT": "<strong>Recommandations OMS</strong><br><br><I>Pour les personnes âgées, la température idéale de chauffage se situe plutôt aux alentours de 24°C pour les pièces à vivre en journée, et 19°C la nuit.</I><br><br><I>Durant les phases de canicule, la température de la pièce ne devrait pas excéder 32°C la journée et 24°C la nuit.</I><a href=\"https://www.who.int/news-room/fact-sheets/detail/climate-change-heat-and-health\">Plus d'informations</a>"
        },
        "CONFIG_THRESHOLD": {
            "PREFIX": "Déclencher l'alerte si la valeur remontée par le dispositif est ",
            "OPERATOR": "Opérateur",
            "TEMPERATURE": "Unité (ex: °C)"
        }
    },
    "DOOR": {
        "TITLE": "Suivi de l'état des capteurs d'ouverture de porte",
        "STATES": {
            "open": "Ouvert",
            "close": "Fermé"
        },
        "SELECTION_TITLE": "Capteur d'ouverture de porte",
        "NO_DATA": "Pas de données"
    },
    "RANGE": {
        "ACQUIRED": "Période d'acquisition",
        "FROM": "De",
        "TO": "Jusqu'à",
        "SELECT_ONE_HOUR": "Dernière heure",
        "SELECT_SIX_HOURS": "6 dernières heures",
        "SELECT_ONE_DAY": "Aujourd'hui",
        "SELECT_TWO_DAY": "2 jours",
        "SELECT_ONE_WEEK": "1 semaine",
        "SELECT_TWO_WEEK": "2 semaines",
        "SELECT_ONE_MONTH": "1 mois",
        "SELECT_SIX_MONTH": "6 mois",
        "BETWEEN_TWO_DATES": "Entre deux dates",
        "CURRENT_YEAR": "Année courante"
    },
    "SCHEDULE": {
        "PROFILE_NAME": "Nom",
        "PROFILE_PLACEHOLDER": "Matin, soir, week-end, ...",
        "PROFILE_NOTIF": "Jeu de notification par défaut",
        "MODIFY_DAY": "Modifier la planification du {{day}}",
        "COPY_DAY": "Dupliquer la planification",
        "COPY_BODY": "Sélectionner les jours où vous souhaitez dupliquer la configuration du {{day}}",
        "TIME_RANGE": "{{from}} à {{to}} - Jeu de notifications: {{name}}",
        "CONFIGURED_TIME_RANGE": "Plages horaires configurées",
        "SELECT_CONFIG": "Jeu de notifications",
        "SELECT_DAYS": "Jours",
        "SELECT_TIME_RANGE": "Plage horaire",
        "WHOLE_DAY": "Journée entière",
        "COPY": "Dupliquer",
        "RESET": "Effacer",
        "RESET_ALL": "Tout effacer",
        "SIMPLIFIED_SCHEDULING": "Planification simplifiée",
        "FREE_SLOT": "Créneau sans notification",
        "SCHEDULE_ACTIVATE": "Planification activée",
        "SCHEDULE_EMPTY": "Aucune plage de temps sélectionnée",
        "INFOS": "<p>La planification des jeux de notifications permet d'assigner un jeu de notification à une plage horaire précise.</p><div class='alert alert-success'>Exemple : je possède un jeu de notification &laquo;Matin&raquo; qui correspond à l'envoi d'un mail à &laquo;exemple@co-assist.fr&raquo;.<br/>Je peux assigner ce jeu de notification du lundi au vendredi de 6 h à 12 h afin de recevoir un e-mail en cas d'alerte uniquement dans cette plage horaire.</div><p>Il est possible de planifier plusieurs jeux de notifications dans une seule journée et de la dupliquer (copier coller) aux autres jours de la semaine. </p>"
    },
    "ADDRESS_AUTOCOMPLETE": {
        "ERROR_SELECTION": "Merci de choisir une adresse dans la liste proposée"
    },
    "MAT_PAGINATOR": {
        "FIRST_PAGE": "Première page",
        "ITEMS_PER_PAGE": "Utilisateurs par page",
        "LAST_PAGE": "Dernière page",
        "NEXT_PAGE": "Page suivante",
        "PREVIOUS_PAGE": "Page précédente",
        "OF": "sur"
    },
    "DEVICES": {
        "SETTINGS": {
            "button_long_pressure": "Durée d'appui du bouton",
            "realTimeTracker": "Suivi de position",
            "time_mode": "Affichage de l'heure",
            "utc_time_zone": "Fuseau horaire"
        }
    },
    "ALERT_DETAILS": {
        "TITLE": "Descriptif de l'alerte de {{name}}",
        "DETAILS": "Détails de l'alerte",
        "DEVICE_TYPE": "Type de dispositif",
        "FLOW": "Déroulement de l'alerte",
        "ID": "Identifiant de l'alerte",
        "DISPLAY_NAME": "Utilisateur",
        "TYPE": "Type d'alerte",
        "STATUS": "Statut de l'alerte",
        "START": "Lancement de l'alerte",
        "DATE": "Date de l'alerte",
        "START_TIME": "Heure de début",
        "END_TIME": "Heure de fin",
        "ACK_TIME": "Heure d'acquittement",
        "LAST_UPDATE": "Dernière mise à jour",
        "QUALIFICATION": "Qualification de l'évènement",
        "COMMENT": "Observations",
        "HANDLE": "Prise en charge",
        "ACKNOWLEDGE": "Acquittement"
    },
    "ALERT_STATUS": {
        "ACQUITTED_BY": {
            "IN_SITU": "Acquittée In Situ",
            "APP": "Acquittée via l'application",
            "CALL": "Acquittée par téléphone",
            "BY": "par {{helperDisplayName}}"
        },
        "acquitted": "Acquittée",
        "close": "Clôturée",
        "expired": "Expirée",
        "notifying": "Notification",
        "handle": "Prise en charge par {{name}}",
        "interrupted": "Annulée par l'utilisateur",
        "start": "Lancement",
        "first_call": "Début du cycle d'appels",
        "last_call": "Fin du cycle d'appels",
        "LOCATION": "Localisation: {{place}}",
        "LOCATION_SINCE": "il y {{time}}",
        "waiting_for_response": "En attente de réponse",
        "waiting_for_handling": "En attente de prise en charge",
        "waiting_for_acquitting": "En attente d'acquittement.<br/> Alerte prise en charge par <em>{{name}}</em>.",
        "waiting_for_closing": "En attente de clôture"
    },
    "ALERT_QUALIFICATION": {
        "TITLE": "Répartition des alertes par qualification",
        "NO_ALERT": "Pas d'alerte",
        "ALERT_NUMBER": "Nombre d'alertes",
        "undefined": {
            "TITLE": "Non qualifié",
            "HELPER": "L'évènement n'a pas été qualifié"
        },
        "alert": {
            "TITLE": "Alerte",
            "HELPER": "Alerte liée à une situation de détresse ou Alerte technique d'un dispositif (batterie faible, dispositif non fonctionnel ...)"
        },
        "test": {
            "TITLE": "Test",
            "HELPER": "Alerte générée afin de tester un dispositif ou une notification"
        },
        "inappropriate": {
            "TITLE": "Déclenchement intempestif",
            "HELPER": "Alerte déclenchée par inadvertance ou faux positif"
        },
        "courtesy": {
            "TITLE": "Appel de courtoisie",
            "HELPER": "Alerte liée à une raison autre qu'une situation de détresse, par exemple une besoin d'assistance pour une tâche de la vie quotidienne"
        },
        "duplicate": {
            "TITLE": "Doublon",
            "HELPER": "Alerte déclenchée alors qu'une alerte est déjà en cours"
        }
    },
    "ALERT_ACTION": {
        "HANDLE": "Prendre en charge",
        "ACKNOWLEDGE": "Acquitter",
        "HANDLE_ALL": "Prendre en charge toutes les alertes de l'utilisateur",
        "ACKNOWLEDGE_ALL": "Acquitter toutes les alertes de l'utilisateur (hors acquittement in situ)",
        "ACKNOWLEDGEMENT_IN_SITU": "Acquittement in situ",
        "ACKNOWLEDGEMENT_IN_SITU_EXPLANATION": "L’alerte doit être acquittée sur l'un des dispositifs de l’utilisateur",
        "QUALIFY": "Qualifier l'alerte"
    },
    "CATALOG": {
        "TITLE": "Catalogue",
        "STOCK": "Stock disponible : {{stock}}",
        "OUT_STOCK": "Rupture de stock",
        "REPLENISHMENT": "Réapprovisionnement",
        "END_OF_SERIES": "Fin de série",
        "FILTER_TITLE": "Filtrer par équipement",
        "FILTER_VALUE": " et {{counter}} autre(s) équipement(s)",
        "FILTER_ALL": "Tous les équipements",
        "NO_ITEMS": "Aucun accessoire disponible pour cet équipement",
        "STAR_PRODUCT": "Produit phare, réapprovisionnement rapide"
    },
    "BATTERY_TO_BE_CHARGED": {
        "MODULE_ID": "moduleID",
        "DISPLAY_NAME": "Utilisateur",
        "BATTERY_LEVEL": "Niveau de batterie",
        "NO_LOW_BATTERY": "Le niveau de batterie des montres est suffisant"
    },
    "CAW_SETTINGS": {
        "UNSYNCHRONIZED": "Paramètre(s) non synchronisé(s)",
        "clock_mode_analogDigit": "Affichage de l'heure",
        "real_time_tracking": "Suivi de position",
        "utc_time_zone": "Fuseau horaire",
        "button_long_pressure": "Durée d'appui du bouton",
        "fall": "Détection de chute",
        "button": "Appui du bouton"
    },
    "DIALOG_UPLOAD_FILE": {
        "TITLE": "Mettre à jour l'image de profil",
        "BUTTON": "Choisir une image",
        "DELETE": "Restaurer l'image par défaut",
        "INVALID_IMAGE_SIZE": "Image trop grande, taille maximale {{maxImageSize}} Ko",
        "INVALID_IMAGE_TYPE": "Format d'image incorect, formats acceptés : {{acceptedType}}",
        "DIALOG_INFO": {
            "TITLE": "Changer l'image de profil",
            "TEXT": "Cette option vous permet de modifier votre image de profil.<br><br><b>Formats acceptés : {{acceptedType}}<br>Taille maximale : {{maxImageSize}} Ko</b>"
        }
    },
    "SELECT_CUSTOM": {
        "ALL_FIELDS": "Tous les champs"
    },
    "HUB": {
        "CHOOSE_MODE": "Quelle service souhaitez-vous parcourir ?",
        "TELEMETRY": "Service de télémesure",
        "ALERT": "Service d'alerte",
        "SWITCH": "Basculer vers le '{{to}}'"
    },
    "TELEMETRY": {
        "PDF": "Générer le relevé d'information",
        "EDIT_FEES": "Edition de la tarification",
        "GENERATE_ENTRY_FORM": "Valider et générer le formulaire d'entrée",
        "EXPORT_CONSUMPTION_DATA": "Export des données du {{from}} au {{to}}",
        "SHOW_CONSUMPTION": "Afficher la consommation",
        "ACCOMODATION_SELECTION": "Sélectionner le logement",
        "LAST_ENTRY_DATE": "Date d'entrée de l'occupant",
        "NEW_ENTRY_DATE": "Date d'entrée du nouvel occupant",
        "EXPORT_DATE": "Date du relevé",
        "DECLARE_NEW_TENANT": "Déclaration d'un nouvel occupant",
        "EXPORT_REPORT": "Génération d'un relevé d'information",
        "EDIT_REPORT": "Edition d'un relevé d'information",
        "CONSUMPTION": "Consommation",
        "CONSUMPTION_PRICE": "Saisir un prix de refacturation au m³",
        "EXPORT_TITLE": "Exporter le relevé de consommation de",
        "INCLUDE_SUBSCRIPTION_FEE": "Inclure le montant des frais d'abonnement ",
        "INCLUDE_CONSUMPTION_FEE": "Inclure le montant des consommations: ",
        "EXPORT_ALL": "Consommation de tous les logements",
        "AGGREGATED_VIEW": "Vue aggrégée",
        "ACCOMODATION": "Logements",
        "WATER_METER": "Compteurs",
        "DOWNLOAD_DATA": "Télécharger les données | CSV",
        "SET_DATES": "Choix de la période",
        "STARTING_DATE": "Date de début",
        "ENDING_DATE": "Date de fin",
        "INVALID_STARTING_DATE": "Date de début invalide",
        "INVALID_ENDING_DATE": "Date de fin invalide",
        "COLD_WATER_METER": "Compteur eau froide",
        "HOT_WATER_METER": "Compteur eau chaude",
        "GLOBAL_CONSUMPTION": "Consommation totale de l'établissement",
        "COLD_WATER_GLOBAL_CONSUMPTION": "Consommation d'eau froide totale de l'établissement",
        "HOT_WATER_GLOBAL_CONSUMPTION": "Consommation d'eau chaude totale de l'établissement",
        "SUBSCRIPTION_FEE": "Tarif abonnement par an",
        "HOT_WATER_CONSUMPTION_FEE": "Tarif eau chaude par m3",
        "COLD_WATER_CONSUMPTION_FEE": "Tarif eau froide par m3",
        "ALREADY_DEFINED": "Une date d'entrée est déjà définie",
        "SELECT_YEAR": "Choisissez une année",
        "FEES_NOT_EDITABLE": "Les tarifs ne sont modifiables que sur l'année courante"
    },
    "CUSTOM_RANGE_PICKER": {
        "PRE_DEFINED_RANGE": {
            "LAST_WEEK": "Dernière semaine",
            "CURRENT_MONTH": "Mois en cours",
            "LAST_MONTH": "Mois précédent",
            "LAST_SEMESTER": "Semestre précédent",
            "MONTH_TO_DATE": "Dernier mois à date",
            "YEAR_TO_DATE": "Dernière année à date"
        },
        "SPECIFIC_RANGE": {
            "CUSTOM_RANGE": "Entre deux dates",
            "SINCE_ENTRY": "Depuis la date d'arrivée",
            "SINCE_LAST_FLAG": "Depuis la dernière échéance"
        }
    },
    "QUICK_LOGIN": {
        "TITLE": "Connexion rapide à l'application android",
        "VALIDITY": "Le QRCode est valide jusqu'au {{date}}",
        "EXPLANATION": "Assurez-vous que l'application Co-assist est installée, scannez le QRCode à partir de l'appareil photo de votre smartphone Android, puis suivez le lien qui apparaît pour vous connecter instantanément."
    },
    "TIME_AGO": {
        "FEW_SECONDS": "Il y a quelques secondes",
        "A_MINUTE": "Il y a une minute",
        "N_MINUTE": "Il y a {{minutes}} minutes",
        "MORE_THAN_HOUR": "Il y a plus d'une heure"
    }
}